import _getIterator from "/app/node_modules/babel-runtime/core-js/get-iterator";
import _toConsumableArray from "/app/node_modules/babel-runtime/helpers/toConsumableArray";
import _Object$assign from "/app/node_modules/babel-runtime/core-js/object/assign";
import _typeof from "/app/node_modules/babel-runtime/helpers/typeof";
import _Object$values from "/app/node_modules/babel-runtime/core-js/object/values";
import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _objectDestructuringEmpty from "/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import { AddressTypeEnum } from "@affiliation/enums";
import { affiliationTypeEnum, currencyTypeEnum, presentialPosEnum, virtualPosEnum, subProductEnum } from "../../enums";
import { mapRequestAffiliation, mapRequestVirtualAffiliation, mapToVirtualValue, calculateUbigeo, mapRequestGenerateCommerceCode, responseToState, newMapRequestGenerateQrCode, newMapRequestGenerateCommerceCode, newMapRequestGenerateCommerceCodeMultiAdress, mapperMultiAdressCodes } from "~/mappers";
import { settingsConfig } from "../../../config/settings";
import { AffiliationApi, MailApi, MasterApi, MultiDirectionsApi } from "~/api";
import { ConflictError, WarningError } from "~/abstractions/errors";
import virtual from "~~/jsons/virtual";
import pos from "~~/jsons/pos";
import form from "./utils";
import { OnHoldError } from "../../api/errors/on-hold";
import { corporateSegment } from "~/constants.js";
import { encryptText, decryptText } from '~/plugins/crypto';
var ROOT = {
	root: true
};

var contact = {
	fullname: null,
	email: null,
	phone: null
};

var developer = _extends({
	developmentType: "",
	company: null
}, contact);

var integration = {
	paymentForm: ""
};

var mccnValidation = function mccnValidation(currencyType, affiliationType) {
	switch (affiliationType) {
		case affiliationTypeEnum.PERMANENT:
			switch (currencyType) {
				case currencyTypeEnum.SOLES:
				case currencyTypeEnum.DOLARES:
					return "7777";
				case currencyTypeEnum.SOLES_Y_DOLARES:
					return "0100";
			}
			break;
		case affiliationTypeEnum.TEMPORAL:
			switch (currencyType) {
				case currencyTypeEnum.SOLES:
				case currencyTypeEnum.DOLARES:
				case currencyTypeEnum.SOLES_Y_DOLARES:
					return "1000";
			}
			break;
	}
	return "";
};

var esperar = function esperar(timeout) {
	return new _Promise(function (resolve) {
		setTimeout(function () {
			resolve();
		}, timeout);
	});
};

export var state = function state() {
	return {
		tipoEquipo: "PVR",
		esPOSPinpadMpos: "POS01",
		logoutInAffiliation: false,
		idAffiliation: 0,
		idAffiliationProcess: 0,
		step: 1, // Numero de step de una nueva afiliacion
		showSteppeds: false,
		productType: null,
		productChoice: null,
		processInitDate: "",
		posSelected: {
			pos: "",
			id: null,
			priceSoles: "",
			priceDolares: "",
			TipoConexion: "",
			rental: {
				uniqueMoney: {
					soles: 0,
					dolares: 0
				},
				biMoney: {
					soles: 0,
					dolares: 0
				}
			},
			tarifas: {}
		},
		rucValidation: {
			ruc: null,
			businessName: "",
			consultDate: null
		},
		membershipType: {
			type: "IND",
			startDate: null,
			endDate: null
		},
		comission: {
			codigo: "",
			mensaje: "",
			ruc: "",
			producto: "",
			subProducto: "",
			mccInternacional: "",
			plataforma: "",
			comisionCreditoOtraPlataforma: "",
			comisionDebitoOtraPlataforma: "",
			comisionesMarca: [{
				idMarca: "",
				descMarca: "",
				idProgramaPorcentual: "",
				nombreProgramaPorcentual: "",
				idProgramaFlat: "",
				nombreProgramaFlat: "",
				indicadorCampanaPorcentual: false,
				indicadorCampanaFlat: false,
				duracionCampana: 0,
				fechaInicioCampana: "",
				fechaFinCampana: "",
				comisionCredito: "",
				comisionDebito: "",
				comisionForaneaCredito: "",
				comisionForaneaDebito: "",
				flatCredito: "",
				flatDebito: "",
				flatForaneaCredito: "",
				flatForaneaDebito: "",
				indicadorMarca: false
			}]
		},
		legalRepresentativeData: {
			id: 0,
			firstName: "",
			maternalName: "",
			paternalName: "",
			documentType: "",
			documentNumber: "",
			cellPhone: "",
			secondPhone: "",
			email: "",
			birthdate: "",
			consultDate: null
		},
		businessData: {
			adminCommerEquals: "",
			refData: [],
			commerceData: {
				id: null,
				tradeName: "",
				email: "",
				commercialBusiness: null,
				nationalMcc: "",
				applyToPartnerPlan: ""
			},
			commercialAddress: {
				id: null,
				department: "",
				province: "",
				district: "",
				typeOfRoad: "",
				nameOfRoad: "",
				numberOfRoad: "",
				plusCode: "",
				km: "",
				block: "",
				allotment: "",
				interiorType: "",
				interior: "",
				reference: "",
				cellPhone: "",
				prefix: "",
				landline: "",
				typeUrbanHabilitation: {},
				urbanHabilitation: ""
			},
			administrativeAddress: {
				id: null,
				department: "",
				province: "",
				district: "",
				typeOfRoad: "",
				nameOfRoad: "",
				numberOfRoad: "",
				plusCode: "",
				km: "",
				block: "",
				allotment: "",
				interiorType: "",
				interior: "",
				reference: "",
				cellPhone: "",
				prefix: "",
				landline: "",
				typeUrbanHabilitation: {},
				urbanHabilitation: ""
			}
		},
		businessSchedule: {
			id: null,
			idSchedule: null,
			schedule: [],
			initDay: "",
			endDay: "",
			startTime: null,
			endTime: null
		},
		installationSchedule: {
			id: null,
			serviceHours: [],
			name: "",
			phone: "",
			paternalLastname: null,
			maternalLastname: null,
			email: null,
			documentType: null,
			documentNumber: null
		},
		paymentData: {
			currencyType: "",
			idSoles: null,
			bankNameSoles: "",
			accountTypeSoles: "",
			accountNumberSoles: "",
			alternativeAccountNumberSoles: "",
			idDolares: null,
			bankNameDolares: "",
			accountTypeDolares: "",
			accountNumberDolares: "",
			alternativeAccountNumberDolares: ""
		},
		membershipRequirements: {
			url: [],
			sapFiles: []
		},
		osvType: {
			osvType: null,
			commercialCode: null
		},
		quotation: {
			posName: "",
			posNumber: "1",
			taxQuota: "01",
			installationCost: null,
			installationCostDolar: null,
			rentalPrice: 0.0,
			rentalPriceDolares: 0.0,
			maintenancePriceCost: 0,
			maintenancePriceCostDolar: 0,
			stateShippingCost: 5.0,
			stateShippingCostDolar: 1.5,
			creditCardCommission: "4.5%",
			debitCardCommission: "3.8%"
		},
		afilliationSummary: {
			id: null,
			equiptment: "",
			dues: "",
			authorizePersonalDataTreatment: null,
			posName: null,
			posNumber: null,
			installationCost: null,
			installationCostDolar: null,
			rentalSoles: null,
			rentalDolares: null,
			maintenancePriceCost: null,
			maintenancePriceCostDolar: null,
			usePlatformWebCost: null
		},
		ubigeo: "",
		num_incidencia: settingsConfig.num_incidencia,
		preliminaryCheckResult: {},
		commercialTariffResults: [],
		commerceCode: [{ code: null, text: "" }],
		commerceCodeInProcess: "",
		affiliateResults: [],
		virtual: {
			user: {
				id: 0,
				usingLegalRepresentativeData: false,
				fullname: "",
				email: "",
				phone: ""
			},
			app: {
				id: 0,
				name: "",
				link: "",
				platform: "",
				developer: developer,
				integration: integration
			},
			webSite: {
				id: 0,
				url: "",
				developer: developer,
				integration: integration
			}
		},
		typeAffiliation: [{
			codigo: "IND",
			descripcion: "Permanente",
			tipo: "null"
		}, {
			codigo: "TMP",
			descripcion: "Temporal",
			tipo: "null"
		}],
		vitualCommerceData: [],
		administrativePlatform: [],
		idTransaction: null,
		validateCrmClientData: null,
		consultMcciResult: {},
		registerStatus: null,
		onHold: null,
		applyToCodeQR: false,
		modalityType: {},
		segmento: "",
		typeModalityTitle: "",
		currencyTypeBimoneda: "",
		commerceCodePadre: "",
		mcciForGrifo: "",
		idTransactionBimoneda: "",
		multiAdress: [],
		dataTable: [],
		infoTable: {
			countInHold: 0,
			countNotWorked: 0,
			countWorked: 0
		},
		inMultiAdressisSameDirection: true,
		corresponsaliaData: {
			header: {
				agent: null,
				affiliationType: null,
				bankAccount: null
			},
			agentData: {
				codigoAgenciaMatriz: null,
				oficinaMatriz: null,
				tipoOficinaMatriz: null,
				ubigeoOficinaMatriz: null,
				codigoMacroRegion: null,
				macroRegion: null,
				area: null
			}
		}
	};
};

export var getters = {
	productType: function productType(state) {
		return state.productChoice;
	},
	isVirtual: function isVirtual(state) {
		return state.productType === "2";
	},
	isPresential: function isPresential(state) {
		return state.productType === "1";
	},
	showSteppeds: function showSteppeds(state) {
		return state.showSteppeds;
	},
	commercialName: function commercialName(state) {
		return state.businessData.commerceData.tradeName ? state.businessData.commerceData.tradeName.replace(/\./g, "") : "";
	},
	posName: function posName(state) {
		return (state.posSelected || {}).pos || "";
	},
	isValidConsultMcci: function isValidConsultMcci(state) {
		return (state.consultMcciResult || {}).statusCode === "0";
	},
	isPagoWeb: function isPagoWeb(state) {
		return state.posSelected.pos === virtualPosEnum.PAGO_WEB;
	},
	isBimoneda: function isBimoneda(state) {
		return state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES;
	},
	idTransactionBimoneda: function idTransactionBimoneda(state) {
		return state.idTransactionBimoneda;
	},
	countAffiliations: function countAffiliations(state) {
		return state.multiAdress.length;
	},
	dataTable: function dataTable(state) {
		return state.dataTable;
	},
	infoTable: function infoTable(state) {
		return state.infoTable;
	},
	currentStep: function currentStep(state) {
		return state.step;
	}
};

export var actions = {
	getLogsType: function getLogsType(_ref, _ref2) {
		var logType = _ref2.logType,
		    date = _ref2.date;

		_objectDestructuringEmpty(_ref);

		return new AffiliationApi(this.$axios).getLogsType({
			logType: logType,
			date: date
		});
	},
	deleteFileFromS3: function deleteFileFromS3(_ref3, key) {
		_objectDestructuringEmpty(_ref3);

		return new AffiliationApi(this.$axios).deleteFileFromS3(key);
	},
	preliminaryCheck: function preliminaryCheck(_ref4) {
		var state = _ref4.state,
		    commit = _ref4.commit;

		return new AffiliationApi(this.$axios).preliminaryCheck({
			businessName: state.rucValidation.businessName,
			ubigeo: state.ubigeo,
			email: state.legalRepresentativeData.email,
			paternalName: state.legalRepresentativeData.paternalName,
			maternalName: state.legalRepresentativeData.maternalName,
			firstNames: state.legalRepresentativeData.firstName,
			documentType: state.legalRepresentativeData.documentType.Code + "",
			documentNumber: state.legalRepresentativeData.documentNumber,
			ruc: state.rucValidation.ruc,
			comercialName: state.businessData.commerceData.tradeName
		});
	},
	commercialTariff: function () {
		var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
			var state = _ref5.state,
			    commit = _ref5.commit,
			    dispatch = _ref5.dispatch,
			    getters = _ref5.getters,
			    rootState = _ref5.rootState;
			var posNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

			var promises, posSelected, platform, CHANNEL, SOLES, DOLARES, SOLES_Y_DOLARES, CREDIT_COMMISSION, DEBIT_COMMISSION, VENTA, ALQUILER, EXTENDIDA, mcci, element, responseTariff, _responseTariff, _responseTariff2, _responseTariff3, i, _element, _responseTariff4, _responseTariff5, _responseTariff6, _responseTariff7, _responseTariff8, _responseTariff9, _responseTariff10, _responseTariff11, _responseTariff12, _responseTariff13, _responseTariff14, _responseTariff15, _responseTariff16, _responseTariff17, _i, _element2, _responseTariff18, _responseTariff19, _responseTariff20, _responseTariff21, _responseTariff22, _responseTariff23;

			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							console.log("jahc-----------Setting commercial tariff------");
							console.log("jahc-----------Currency type", state.paymentData.currencyType);
							// posNumber = Number(posNumber);
							// if (isNaN(posNumber)) posNumber = 0;

							// const { applyToPartnerPlan } = state.businessData.commerceData;

							promises = [];
							// let parentCode = '';
							// let multicommerceName = '';
							// let connectionType = '';
							// let workType = '';
							// let osvType = Number(state.osvType.osvType);

							posSelected = state.posSelected;
							platform = "Herramienta de Afiliación";
							CHANNEL = rootState.user.channelName;
							SOLES = "Soles";
							DOLARES = "Dolares";
							SOLES_Y_DOLARES = "Soles y Dolares";
							CREDIT_COMMISSION = 3.45;
							DEBIT_COMMISSION = 3.45;
							VENTA = 1;
							ALQUILER = 2;
							EXTENDIDA = 3;
							mcci = state.mcciForGrifo;


							if (currencyTypeEnum.SOLES_Y_DOLARES === state.paymentData.currencyType || currencyTypeEnum.SOLES === state.paymentData.currencyType) promises.push({
								currency: currencyTypeEnum.SOLES,
								paymentData: {
									bankName: state.paymentData.bankNameSoles.Code,
									accountType: mapToVirtualValue("tipoCuenta", state.paymentData.accountTypeSoles.Name),
									accountNumber: state.paymentData.accountNumberSoles,
									alternativeAccountNumber: state.paymentData.alternativeAccountNumberSoles
								}
							});

							if (currencyTypeEnum.SOLES_Y_DOLARES === state.paymentData.currencyType || currencyTypeEnum.DOLARES === state.paymentData.currencyType) promises.push({
								currency: currencyTypeEnum.DOLARES,
								paymentData: {
									bankName: state.paymentData.bankNameDolares.Code,
									accountType: mapToVirtualValue("tipoCuenta", state.paymentData.accountTypeDolares.Name),
									accountNumber: state.paymentData.accountNumberDolares,
									alternativeAccountNumber: state.paymentData.alternativeAccountNumberDolares
								}
							});
							console.log("jahc-----------isPresential", getters.isPresential);
							console.log("jahc-----------modality", state.modalityType);

							if (!getters.isPresential) {
								_context.next = 195;
								break;
							}

							element = promises[0];

							if (!(currencyTypeEnum.SOLES_Y_DOLARES === state.paymentData.currencyType)) {
								_context.next = 60;
								break;
							}

							if (!(state.posSelected.pos === "POS fijo Internet" && state.modalityType.type === ALQUILER)) {
								_context.next = 31;
								break;
							}

							_context.next = 25;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Fijo Internet Alquiler",
								currency: SOLES_Y_DOLARES
							});

						case 25:
							responseTariff = _context.sent;

							//element.currency = currencyTypeEnum.SOLES_Y_DOLARES
							element.installationCost = 20;
							element.rental = 6;
							element.creditCommission = CREDIT_COMMISSION;
							element.debitCommission = DEBIT_COMMISSION;
							element.tariff = responseTariff;

						case 31:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === ALQUILER)) {
								_context.next = 40;
								break;
							}

							_context.next = 34;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Alquiler",
								currency: SOLES_Y_DOLARES
							});

						case 34:
							_responseTariff = _context.sent;

							// element.currency = currencyTypeEnum.SOLES_Y_DOLARES
							element.installationCost = 20;
							element.rental = 6;
							element.creditCommission = CREDIT_COMMISSION;
							element.debitCommission = DEBIT_COMMISSION;
							element.tariff = _responseTariff;

						case 40:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === VENTA)) {
								_context.next = 49;
								break;
							}

							_context.next = 43;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Básica",
								currency: SOLES_Y_DOLARES
							});

						case 43:
							_responseTariff2 = _context.sent;

							// element.currency = currencyTypeEnum.SOLES_Y_DOLARES
							element.installationCost = 20;
							element.rental = 6;
							element.creditCommission = CREDIT_COMMISSION;
							element.debitCommission = DEBIT_COMMISSION;
							element.tariff = _responseTariff2;
							//   console.log("Deberia entrar aqui ", responseTariff);
							//   console.log("Deberia entrar aqui 2", element.tariff);

						case 49:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === EXTENDIDA)) {
								_context.next = 58;
								break;
							}

							_context.next = 52;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Extendida",
								currency: SOLES_Y_DOLARES
							});

						case 52:
							_responseTariff3 = _context.sent;

							// element.currency = currencyTypeEnum.SOLES_Y_DOLARES
							element.installationCost = 20;
							element.rental = 6;
							element.creditCommission = CREDIT_COMMISSION;
							element.debitCommission = DEBIT_COMMISSION;
							element.tariff = _responseTariff3;

						case 58:
							_context.next = 195;
							break;

						case 60:
							i = 0;

						case 61:
							if (!(i < promises.length)) {
								_context.next = 195;
								break;
							}

							_element = promises[i];

							if (!(_element.currency === currencyTypeEnum.SOLES)) {
								_context.next = 136;
								break;
							}

							if (!(mcci === "5541")) {
								_context.next = 94;
								break;
							}

							if (!(state.posSelected.pos === "POS fijo Internet" && state.modalityType.type === ALQUILER)) {
								_context.next = 74;
								break;
							}

							_context.next = 68;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Fijo Internet Alquiler (Grifos)",
								currency: SOLES
							});

						case 68:
							_responseTariff4 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff4;

						case 74:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === ALQUILER)) {
								_context.next = 83;
								break;
							}

							_context.next = 77;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Alquiler (Grifos)",
								currency: SOLES
							});

						case 77:
							_responseTariff5 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff5;

						case 83:
							if (!(state.posSelected.pos === "Corresponsalía" && state.modalityType.type === ALQUILER)) {
								_context.next = 92;
								break;
							}

							_context.next = 86;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "Corresponsalía Alquiler (Grifos)",
								currency: SOLES
							});

						case 86:
							_responseTariff6 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff6;

						case 92:
							_context.next = 136;
							break;

						case 94:
							if (!(state.posSelected.pos === "POS fijo Internet" && state.modalityType.type === ALQUILER)) {
								_context.next = 103;
								break;
							}

							_context.next = 97;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Fijo Internet Alquiler",
								currency: SOLES
							});

						case 97:
							_responseTariff7 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff7;

						case 103:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === ALQUILER)) {
								_context.next = 112;
								break;
							}

							_context.next = 106;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Alquiler",
								currency: SOLES
							});

						case 106:
							_responseTariff8 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 60;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff8;

						case 112:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === VENTA)) {
								_context.next = 120;
								break;
							}

							_context.next = 115;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Básica",
								currency: SOLES
							});

						case 115:
							_responseTariff9 = _context.sent;

							_element.installationCost = 279;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff9;

						case 120:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === EXTENDIDA)) {
								_context.next = 128;
								break;
							}

							_context.next = 123;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Extendida",
								currency: SOLES
							});

						case 123:
							_responseTariff10 = _context.sent;

							_element.installationCost = 95;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff10;

						case 128:
							if (!(state.posSelected.pos === "Corresponsalía" && state.modalityType.type === ALQUILER)) {
								_context.next = 136;
								break;
							}

							_context.next = 131;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "Corresponsalía Alquiler",
								currency: SOLES
							});

						case 131:
							_responseTariff11 = _context.sent;

							_element.installationCost = 95;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff11;

						case 136:
							if (!(_element.currency === currencyTypeEnum.DOLARES)) {
								_context.next = 192;
								break;
							}

							if (!(mcci === "5541")) {
								_context.next = 158;
								break;
							}

							if (!(state.posSelected.pos === "POS fijo Internet" && state.modalityType.type === ALQUILER)) {
								_context.next = 147;
								break;
							}

							_context.next = 141;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Fijo Internet Alquiler (Grifos)",
								currency: DOLARES
							});

						case 141:
							_responseTariff12 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff12;

						case 147:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === ALQUILER)) {
								_context.next = 156;
								break;
							}

							_context.next = 150;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Alquiler (Grifos)",
								currency: DOLARES
							});

						case 150:
							_responseTariff13 = _context.sent;

							_element.installationCost = 60;
							_element.rental = 18;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff13;

						case 156:
							_context.next = 192;
							break;

						case 158:
							if (!(state.posSelected.pos === "POS fijo Internet" && state.modalityType.type === ALQUILER)) {
								_context.next = 167;
								break;
							}

							_context.next = 161;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Fijo Internet Alquiler",
								currency: DOLARES
							});

						case 161:
							_responseTariff14 = _context.sent;

							_element.installationCost = 20;
							_element.rental = 6;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff14;

						case 167:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === ALQUILER)) {
								_context.next = 176;
								break;
							}

							_context.next = 170;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Alquiler",
								currency: DOLARES
							});

						case 170:
							_responseTariff15 = _context.sent;

							_element.installationCost = 20;
							_element.rental = 20;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff15;

						case 176:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === VENTA)) {
								_context.next = 184;
								break;
							}

							_context.next = 179;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Básica",
								currency: DOLARES
							});

						case 179:
							_responseTariff16 = _context.sent;

							_element.installationCost = 90;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff16;

						case 184:
							if (!(state.posSelected.pos === "POS Inalámbrico" && state.modalityType.type === EXTENDIDA)) {
								_context.next = 192;
								break;
							}

							_context.next = 187;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: "POS Inalámbrico Venta Extendida",
								currency: DOLARES
							});

						case 187:
							_responseTariff17 = _context.sent;

							_element.installationCost = 25;
							_element.creditCommission = CREDIT_COMMISSION;
							_element.debitCommission = DEBIT_COMMISSION;
							_element.tariff = _responseTariff17;

						case 192:
							i++;
							_context.next = 61;
							break;

						case 195:
							if (!getters.isVirtual) {
								_context.next = 236;
								break;
							}

							_i = 0;

						case 197:
							if (!(_i < promises.length)) {
								_context.next = 236;
								break;
							}

							_element2 = promises[_i];

							_element2.creditCommission = CREDIT_COMMISSION;
							_element2.debitCommission = DEBIT_COMMISSION;

							if (!(_element2.currency === currencyTypeEnum.SOLES)) {
								_context.next = 217;
								break;
							}

							if (!this.$isPagoLink()) {
								_context.next = 207;
								break;
							}

							_context.next = 205;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: SOLES
							});

						case 205:
							_responseTariff18 = _context.sent;

							_element2.tariff = _responseTariff18;

						case 207:
							if (!this.$isPagoWeb()) {
								_context.next = 212;
								break;
							}

							_context.next = 210;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: SOLES
							});

						case 210:
							_responseTariff19 = _context.sent;

							_element2.tariff = _responseTariff19;

						case 212:
							if (!this.$isPagoApp()) {
								_context.next = 217;
								break;
							}

							_context.next = 215;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: SOLES
							});

						case 215:
							_responseTariff20 = _context.sent;

							_element2.tariff = _responseTariff20;

						case 217:
							if (!(_element2.currency === currencyTypeEnum.DOLARES)) {
								_context.next = 233;
								break;
							}

							if (!this.$isPagoLink()) {
								_context.next = 223;
								break;
							}

							_context.next = 221;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: DOLARES
							});

						case 221:
							_responseTariff21 = _context.sent;

							_element2.tariff = _responseTariff21;

						case 223:
							if (!this.$isPagoWeb()) {
								_context.next = 228;
								break;
							}

							_context.next = 226;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: DOLARES
							});

						case 226:
							_responseTariff22 = _context.sent;

							_element2.tariff = _responseTariff22;

						case 228:
							if (!this.$isPagoApp()) {
								_context.next = 233;
								break;
							}

							_context.next = 231;
							return new MasterApi(this.$axios).findTariff({
								platform: platform,
								channel: CHANNEL,
								subproduct: posSelected.pos,
								currency: DOLARES
							});

						case 231:
							_responseTariff23 = _context.sent;

							_element2.tariff = _responseTariff23;

						case 233:
							_i++;
							_context.next = 197;
							break;

						case 236:
							_context.t0 = commit;
							_context.next = 239;
							return _Promise.all(promises);

						case 239:
							_context.t1 = _context.sent;
							(0, _context.t0)("setCommercialTariffs", _context.t1);

						case 241:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function commercialTariff(_x2) {
			return _ref6.apply(this, arguments);
		}

		return commercialTariff;
	}(),
	sendSummaryV2: function () {
		var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref7) {
			var state = _ref7.state,
			    dispatch = _ref7.dispatch,
			    getters = _ref7.getters;

			var commercialTariffDolares, commercialTariffSoles, equipmentQuantity, _state$legalRepresent, firstName, maternalName, paternalName, isVirtual, solutionType, _ref9, price, tarifas, _state$posSelected$ta, shippingFull, shippingFullSoles, renovation, renovationDolares, forSale, maintenancePriceCost, maintenancePriceCostDolar, _state$afilliationSum, authorizePersonalDataTreatment, rentalSoles, rentalDolares, installationCost, installationCostDolar, applyToPartnerPlan, PosIdIntTelf, soles, dolares;

			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							// console.log('state SendSummaryV2', state)
							commercialTariffDolares = state.commercialTariffResults.find(function (r) {
								return r.currency == currencyTypeEnum.DOLARES;
							}) || { solicitud: {} };
							commercialTariffSoles = state.commercialTariffResults.find(function (r) {
								return r.currency == currencyTypeEnum.SOLES;
							}) || { solicitud: {} };
							equipmentQuantity = state.afilliationSummary && state.afilliationSummary.equipment ? Number(state.afilliationSummary.equipment.value) : 0;
							_state$legalRepresent = state.legalRepresentativeData, firstName = _state$legalRepresent.firstName, maternalName = _state$legalRepresent.maternalName, paternalName = _state$legalRepresent.paternalName;
							isVirtual = this.$isVirtual();
							solutionType = state.posSelected.pos;
							_ref9 = virtual[solutionType.toLowerCase().replace(/ /g, "-")] || {
								price: 0,
								tarifas: {
									shippingFull: null,
									renovation: null,
									renovationDolares: null,
									forSale: null
								}
							}, price = _ref9.price, tarifas = _ref9.tarifas;
							_state$posSelected$ta = state.posSelected.tarifas, shippingFull = _state$posSelected$ta.shippingFull, shippingFullSoles = _state$posSelected$ta.shippingFullSoles, renovation = _state$posSelected$ta.renovation, renovationDolares = _state$posSelected$ta.renovationDolares, forSale = _state$posSelected$ta.forSale;
							maintenancePriceCost = 0;
							maintenancePriceCostDolar = 0;
							_context2.t0 = String(state.posSelected.pos);
							_context2.next = _context2.t0 === virtualPosEnum.PAGO_LINK ? 13 : _context2.t0 === virtualPosEnum.PAGO_WEB ? 16 : _context2.t0 === virtualPosEnum.PAGO_APP ? 19 : 22;
							break;

						case 13:
							maintenancePriceCost = 20;
							maintenancePriceCostDolar = 7;
							return _context2.abrupt("break", 23);

						case 16:
							maintenancePriceCost = 50;
							maintenancePriceCostDolar = 15;
							return _context2.abrupt("break", 23);

						case 19:
							maintenancePriceCost = 0;
							maintenancePriceCostDolar = 0;
							return _context2.abrupt("break", 23);

						case 22:
							return _context2.abrupt("break", 23);

						case 23:
							_state$afilliationSum = state.afilliationSummary, authorizePersonalDataTreatment = _state$afilliationSum.authorizePersonalDataTreatment, rentalSoles = _state$afilliationSum.rentalSoles, rentalDolares = _state$afilliationSum.rentalDolares, installationCost = _state$afilliationSum.installationCost, installationCostDolar = _state$afilliationSum.installationCostDolar;
							applyToPartnerPlan = typeof state.businessData.commerceData.applyToPartnerPlan == "undefined" ? false : state.businessData.commerceData.applyToPartnerPlan;
							PosIdIntTelf = state.posSelected.id == 1 || state.posSelected.id == 2;
							soles = commercialTariffSoles.currency ? true : false;
							dolares = commercialTariffDolares.currency ? true : false;
							_context2.t1 = new MailApi(this.$axios);
							_context2.t2 = state.legalRepresentativeData.email;
							_context2.t3 = dolares;
							_context2.t4 = soles;
							_context2.t5 = state.legalRepresentativeData.email;
							_context2.t6 = this.$toCapitalize(firstName) + " " + this.$toCapitalize(paternalName) + " " + this.$toCapitalize(maternalName);
							_context2.t7 = this.$toCapitalize(state.businessData.commerceData.tradeName);
							_context2.t8 = state.commerceCode;
							_context2.t9 = this.$toCapitalize(state.rucValidation.businessName);
							_context2.t10 = state.rucValidation.ruc;
							_context2.t11 = solutionType;
							_context2.t12 = equipmentQuantity;
							_context2.t13 = (state.typeAffiliation.find(function (ta) {
								return ta.codigo == state.membershipType.type;
							}) || {}).descripcion;
							_context2.t14 = {
								soles: installationCost, //commercialTariffSoles.installationConst,
								dolares: installationCostDolar //commercialTariffDolares.installationConst,
							};
							_context2.t15 = {
								soles: rentalSoles, // (1 * state.quotation.rentalPrice).toFixed(2),
								dolares: rentalDolares // (1 * state.quotation.rentalPriceDolares).toFixed(2),
							};
							_context2.t16 = {
								soles: (1 * state.quotation.stateShippingCost).toFixed(2),
								dolares: (1 * state.quotation.stateShippingCostDolar).toFixed(2)
							};
							_context2.t17 = {
								soles: commercialTariffSoles.debitCommission || 2.99,
								dolares: commercialTariffDolares.debitCommission || 2.99
							};
							_context2.t18 = {
								soles: commercialTariffSoles.creditCommission || 3.99,
								dolares: commercialTariffDolares.creditCommission || 3.99
							};
							_context2.t19 = isVirtual;
							_context2.t20 = solutionType === this.$virtualPosEnum.PAGO_LINK;
							_context2.t21 = getters.isPagoWeb;
							_context2.t22 = solutionType === this.$virtualPosEnum.PAGO_APP;
							_context2.t23 = renovation;
							_context2.t24 = renovationDolares;
							_context2.t25 = price;
							_context2.t26 = String(soles ? shippingFullSoles : dolares ? shippingFull : "").replace("null", "").replace("undefined", "");
							_context2.t27 = forSale;
							_context2.t28 = authorizePersonalDataTreatment === "S";
							_context2.next = 58;
							return dispatch("excelFormartWS");

						case 58:
							_context2.t29 = _context2.sent;
							_context2.t30 = maintenancePriceCost;
							_context2.t31 = maintenancePriceCostDolar;
							_context2.t32 = applyToPartnerPlan;
							_context2.t33 = PosIdIntTelf;
							_context2.t34 = {
								to: _context2.t2,
								dolares: _context2.t3,
								soles: _context2.t4,
								email: _context2.t5,
								fullName: _context2.t6,
								commercialName: _context2.t7,
								commerceCodes: _context2.t8,
								socialName: _context2.t9,
								ruc: _context2.t10,
								solutionType: _context2.t11,
								equipmentQuantity: _context2.t12,
								affiliationType: _context2.t13,
								installationCost: _context2.t14,
								rent: _context2.t15,
								shippingAccountStatement: _context2.t16,
								debitCard: _context2.t17,
								creditCard: _context2.t18,
								isVirtual: _context2.t19,
								isPagoLink: _context2.t20,
								isPagoWeb: _context2.t21,
								isPagoApp: _context2.t22,
								anualCharge: _context2.t23,
								anualChargeDolares: _context2.t24,
								uniqueCharge: _context2.t25,
								shippingVirtual: _context2.t26,
								forSale: _context2.t27,
								authorizePersonalDataTreatment: _context2.t28,
								excelData: _context2.t29,
								maintenancePriceCost: _context2.t30,
								maintenancePriceCostDolar: _context2.t31,
								applyToPartnerPlan: _context2.t32,
								PosIdIntTelf: _context2.t33
							};
							return _context2.abrupt("return", _context2.t1.sendSummaryMail.call(_context2.t1, _context2.t34));

						case 65:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function sendSummaryV2(_x3) {
			return _ref8.apply(this, arguments);
		}

		return sendSummaryV2;
	}(),


	// TODO: Verificar funcionalidad sin codigo de comercio -> idAfiliacion
	reqExcelAffiliation: function () {
		var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref10) {
			var state = _ref10.state,
			    dispatch = _ref10.dispatch;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.t0 = new MailApi(this.$axios);
							_context3.t1 = state.commerceCodeInProcess ? [{ code: state.commerceCodeInProcess, text: "para Soles" }] : state.commerceCode;
							_context3.t2 = this.$isVirtual();
							_context3.next = 5;
							return dispatch("excelFormartWS");

						case 5:
							_context3.t3 = _context3.sent;
							_context3.t4 = {
								commerceCodes: _context3.t1,
								isVirtual: _context3.t2,
								excelData: _context3.t3
							};
							return _context3.abrupt("return", _context3.t0.sendReqExcelAffiliation.call(_context3.t0, _context3.t4));

						case 8:
						case "end":
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function reqExcelAffiliation(_x4) {
			return _ref11.apply(this, arguments);
		}

		return reqExcelAffiliation;
	}(),
	sendSelectedSolution: function sendSelectedSolution(_ref12, email) {
		var state = _ref12.state;
		var _state$legalRepresent2 = state.legalRepresentativeData,
		    firstName = _state$legalRepresent2.firstName,
		    maternalName = _state$legalRepresent2.maternalName,
		    paternalName = _state$legalRepresent2.paternalName;


		return new MailApi(this.$axios).sendSelectedSolution({
			name: state.posSelected.pos,
			email: email,
			personName: firstName + " " + paternalName + " " + maternalName
		});
	},
	validateBankAccountNumber: function validateBankAccountNumber(_ref13, _ref14) {
		var state = _ref13.state;
		var currencyType = _ref14.currencyType,
		    accountNumber = _ref14.accountNumber,
		    accountType = _ref14.accountType,
		    bank = _ref14.bank;

		var currencyCode = void 0;

		switch (currencyType) {
			default:
			case currencyTypeEnum.SOLES_Y_DOLARES:
			case currencyTypeEnum.SOLES:
				currencyCode = "SOL";
				break;
			case currencyTypeEnum.DOLARES:
				currencyCode = "DOL";
				break;
		}

		var request = {
			requestId: state.idTransactionBimoneda ? state.idTransactionBimoneda : state.idTransaction,
			accountNumber: accountNumber,
			bankId: bank,
			accountTypeId: mapToVirtualValue("tipoCuenta", accountType),
			currencyCode: currencyCode
		};

		return new AffiliationApi(this.$axios).validateAccount(request);
	},
	saveProductChoice: function () {
		var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref15, _ref16) {
			var state = _ref15.state,
			    commit = _ref15.commit,
			    rootState = _ref15.rootState;
			var productId = _ref16.productId,
			    productType = _ref16.productType,
			    pos = _ref16.pos;
			var response;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return new AffiliationApi(this.$axios).saveProductChoice({
								idAffiliation: state.idAffiliation,
								idProduct: productId,
								idUser: rootState.user.userId
							});

						case 2:
							response = _context4.sent;

							// console.log("pos: ", pos)
							commit("setIdAffiliation", response);
							commit("setData", { stateName: "productChoice", data: pos.name });
							commit("setData", { stateName: "productType", data: productType });
							commit("setData", {
								stateName: "posSelected",
								data: {
									pos: pos.name,
									id: productId,
									priceSoles: pos.priceSoles,
									priceDolares: pos.priceDolares,
									tarifas: _extends({}, pos.tarifas),
									TipoConexion: pos.TipoConexion,
									rental: _extends({}, pos.rental),
									usePlatformWebCost: pos.usePlatformWebCost || null
								}
							});

						case 7:
						case "end":
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function saveProductChoice(_x5, _x6) {
			return _ref17.apply(this, arguments);
		}

		return saveProductChoice;
	}(),
	getListcommerce: function () {
		var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref18, value) {
			var commit = _ref18.commit;
			var response;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return new AffiliationApi(this.$axios).getListCommerce(value);

						case 2:
							response = _context5.sent;
							return _context5.abrupt("return", response.ListarComerciosResponse.Codigo);

						case 4:
						case "end":
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function getListcommerce(_x7, _x8) {
			return _ref19.apply(this, arguments);
		}

		return getListcommerce;
	}(),
	getRucValidation: function () {
		var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref20, ruc) {
			var commit = _ref20.commit;
			var affiliationApi, consultDate, result, idTransaction, SIC, Desc;
			return _regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							affiliationApi = new AffiliationApi(this.$axios);
							consultDate = this.$moment().format("YYYY-MM-DD");
							_context6.next = 4;
							return affiliationApi.validateCrmClient(ruc);

						case 4:
							result = _context6.sent;
							idTransaction = result.idTransaction, SIC = result.SIC, Desc = result.Desc;

							commit("setIdTransaction", idTransaction);
							commit("setValidateCrmClientData", { SIC: SIC, Desc: Desc, consultDate: consultDate });
							return _context6.abrupt("return", result);

						case 9:
						case "end":
							return _context6.stop();
					}
				}
			}, _callee6, this);
		}));

		function getRucValidation(_x9, _x10) {
			return _ref21.apply(this, arguments);
		}

		return getRucValidation;
	}(),
	getVerifiedEmail: function () {
		var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref22, data) {
			var verifiedEmailApi, result;
			return _regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_objectDestructuringEmpty(_ref22);

							data.transaccionId = data.transaccionId.toString();
							verifiedEmailApi = new MailApi(this.$axios);
							_context7.next = 5;
							return verifiedEmailApi.verifiedEmail(data);

						case 5:
							result = _context7.sent;

							console.warn("RESULT", result);
							_context7.next = 9;
							return result;

						case 9:
							return _context7.abrupt("return", _context7.sent);

						case 10:
						case "end":
							return _context7.stop();
					}
				}
			}, _callee7, this);
		}));

		function getVerifiedEmail(_x11, _x12) {
			return _ref23.apply(this, arguments);
		}

		return getVerifiedEmail;
	}(),
	postVerifiedPhone1: function () {
		var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref24, data) {
			var affiliationApi, result;
			return _regeneratorRuntime.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_objectDestructuringEmpty(_ref24);

							affiliationApi = new AffiliationApi(this.$axios);
							_context8.next = 4;
							return affiliationApi.verifiedPhone1(data);

						case 4:
							result = _context8.sent;
							return _context8.abrupt("return", result);

						case 6:
						case "end":
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function postVerifiedPhone1(_x13, _x14) {
			return _ref25.apply(this, arguments);
		}

		return postVerifiedPhone1;
	}(),
	postVerifiedPhone2: function () {
		var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref26, data) {
			var affiliationApi, result;
			return _regeneratorRuntime.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_objectDestructuringEmpty(_ref26);

							affiliationApi = new AffiliationApi(this.$axios);
							_context9.next = 4;
							return affiliationApi.verifiedPhone2(data);

						case 4:
							result = _context9.sent;
							return _context9.abrupt("return", result);

						case 6:
						case "end":
							return _context9.stop();
					}
				}
			}, _callee9, this);
		}));

		function postVerifiedPhone2(_x15, _x16) {
			return _ref27.apply(this, arguments);
		}

		return postVerifiedPhone2;
	}(),


	//Paso 2 - Declarando funcion
	validateCrmContact: function validateCrmContact(_ref28, _ref29) {
		var state = _ref28.state;
		var firstName = _ref29.firstName,
		    maternalName = _ref29.maternalName,
		    paternalName = _ref29.paternalName,
		    documentNumber = _ref29.documentNumber;

		//Paso 2 - Llamada
		return new AffiliationApi(this.$axios).validateCrmContact({
			requestId: state.idTransaction,
			ruc: state.rucValidation.ruc,
			documentNumber: documentNumber,
			firstname: firstName,
			lastname: paternalName + " " + maternalName
		});
	},


	//Paso 3 - Declarando funcion
	validateCrmOpportunity: function validateCrmOpportunity(_ref30, _ref31) {
		var state = _ref30.state;
		var phoneMobile = _ref31.phoneMobile,
		    phoneWork = _ref31.phoneWork;

		//Paso 3 - Llamada
		return new AffiliationApi(this.$axios).validateCrmOpportunity({
			requestId: state.idTransaction,
			documentNumber: state.legalRepresentativeData.documentNumber,
			email: state.legalRepresentativeData.email,
			firstname: state.legalRepresentativeData.firstName,
			lastname: state.legalRepresentativeData.paternalName + " " + state.legalRepresentativeData.maternalName,
			legalname: state.legalRepresentativeData.paternalName + " " + state.legalRepresentativeData.maternalName + " " + state.legalRepresentativeData.firstName,
			ruc: state.rucValidation.ruc,
			phoneMobile: phoneMobile,
			phoneWork: phoneWork
		});
	},
	saveRuc: function () {
		var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref32, data) {
			var state = _ref32.state,
			    commit = _ref32.commit;
			return _regeneratorRuntime.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							_context10.next = 2;
							return new AffiliationApi(this.$axios).saveRucData({
								idAffiliationId: state.idAffiliation,
								ruc: data.ruc,
								businessName: data.businessName
							});

						case 2:

							commit("setProcessInitDate");
							commit("setData", { stateName: "rucValidation", data: data });
							commit("setStep", true);

						case 5:
						case "end":
							return _context10.stop();
					}
				}
			}, _callee10, this);
		}));

		function saveRuc(_x17, _x18) {
			return _ref33.apply(this, arguments);
		}

		return saveRuc;
	}(),
	saveAgentData: function () {
		var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref34, data) {
			var state = _ref34.state,
			    commit = _ref34.commit;
			return _regeneratorRuntime.wrap(function _callee11$(_context11) {
				while (1) {
					switch (_context11.prev = _context11.next) {
						case 0:
							commit("setCorresponsaliaAgentData", data);
							commit("setStep", true);

						case 2:
						case "end":
							return _context11.stop();
					}
				}
			}, _callee11, this);
		}));

		function saveAgentData(_x19, _x20) {
			return _ref35.apply(this, arguments);
		}

		return saveAgentData;
	}(),
	saveLegalRepresentativeData: function () {
		var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref36, data) {
			var state = _ref36.state,
			    commit = _ref36.commit;
			var idLegalRepresentative;
			return _regeneratorRuntime.wrap(function _callee12$(_context12) {
				while (1) {
					switch (_context12.prev = _context12.next) {
						case 0:
							idLegalRepresentative = Number(state.legalRepresentativeData.id);

							if (isNaN(idLegalRepresentative)) idLegalRepresentative = 0;

							new AffiliationApi(this.$axios).saveLegalRepresentativeData({
								idLegalRepresentative: idLegalRepresentative,
								idAffiliation: state.idAffiliation,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								idDocumentType: data.documentType.IdDocumentType,
								firstName: data.firstName,
								maternalName: data.maternalName,
								paternalName: data.paternalName,
								documentNumber: data.documentNumber,
								cellPhone: data.cellPhone,
								secondPhone: data.secondPhone,
								email: data.email,
								birthdate: data.birthdate
							});
							commit("setData", { stateName: "legalRepresentativeData", data: data });
							commit("setStep", true);

						case 5:
						case "end":
							return _context12.stop();
					}
				}
			}, _callee12, this);
		}));

		function saveLegalRepresentativeData(_x21, _x22) {
			return _ref37.apply(this, arguments);
		}

		return saveLegalRepresentativeData;
	}(),
	saveBusinessData: function () {
		var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref38, data) {
			var state = _ref38.state,
			    commit = _ref38.commit;
			var adminCommerEquals, applyToCodeQR, commerceData, commercialAddress, administrativeAddress, tradeName, email, commercialBusiness, nationalMcc, applyToPartnerPlan, department, province, district, typeOfRoad, nameOfRoad, numberOfRoad, plusCode, km, block, allotment, interiorType, interior, reference, cellPhone, prefix, landline, typeUrbanHabilitation, urbanHabilitation, idBusinessTurn, idCommercialAddress, idAdministrativeAddress;
			return _regeneratorRuntime.wrap(function _callee13$(_context13) {
				while (1) {
					switch (_context13.prev = _context13.next) {
						case 0:
							// console.log("Viendo la data que se setea: ", data);
							adminCommerEquals = data.adminCommerEquals, applyToCodeQR = data.applyToCodeQR, commerceData = data.commerceData, commercialAddress = data.commercialAddress, administrativeAddress = data.administrativeAddress;
							tradeName = commerceData.tradeName, email = commerceData.email, commercialBusiness = commerceData.commercialBusiness, nationalMcc = commerceData.nationalMcc, applyToPartnerPlan = commerceData.applyToPartnerPlan;
							department = commercialAddress.department, province = commercialAddress.province, district = commercialAddress.district, typeOfRoad = commercialAddress.typeOfRoad, nameOfRoad = commercialAddress.nameOfRoad, numberOfRoad = commercialAddress.numberOfRoad, plusCode = commercialAddress.plusCode, km = commercialAddress.km, block = commercialAddress.block, allotment = commercialAddress.allotment, interiorType = commercialAddress.interiorType, interior = commercialAddress.interior, reference = commercialAddress.reference, cellPhone = commercialAddress.cellPhone, prefix = commercialAddress.prefix, landline = commercialAddress.landline, typeUrbanHabilitation = commercialAddress.typeUrbanHabilitation, urbanHabilitation = commercialAddress.urbanHabilitation;
							// console.log("view administrativeAddress: ", administrativeAddress);
							// console.log("view comercialAddres: ", commercialAddress);

							idBusinessTurn = Number(commercialBusiness.IdBusinessTurn);

							if (isNaN(idBusinessTurn)) idBusinessTurn = 0;

							idCommercialAddress = Number(state.businessData.commercialAddress.id);

							if (isNaN(idCommercialAddress)) idCommercialAddress = null;

							idAdministrativeAddress = Number(state.businessData.administrativeAddress.id);

							if (isNaN(idAdministrativeAddress)) idAdministrativeAddress = 0;

							_context13.next = 11;
							return new AffiliationApi(this.$axios).saveCommerceData({
								idAffiliation: state.idAffiliation,
								tradeName: tradeName,
								email: email,
								idBusinessTurn: idBusinessTurn,
								nationalMcc: "",
								applyToPartnerPlan: applyToPartnerPlan || false
							});

						case 11:
							_context13.next = 13;
							return new AffiliationApi(this.$axios).saveAddress({
								adminCommerEquals: adminCommerEquals || true,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								commercialAddress: [{
									idAffiliation: state.idAffiliation,
									idAddressType: 2,
									idCommercialAddress: idCommercialAddress,
									idDepartament: department.IdDepartament,
									idProvince: province.IdProvince,
									idDistrict: district.IdDistrict,
									ubiDep: department.UbiDep || "",
									ubiPro: province.UbiPro || "",
									ubiDis: district.UbiDis || "",
									plusCode: plusCode,
									km: km,
									idInteriorType: interiorType ? interiorType.IdInteriorType : 0,
									idTypeOfRoad: typeOfRoad.IdTypeOfRoad,
									idTypeUrbanHabilitation: typeUrbanHabilitation ? typeUrbanHabilitation.IdTypeUrbanHabilitation : 0,
									urbanHabilitation: urbanHabilitation,
									nameOfRoad: nameOfRoad,
									numberOfRoad: numberOfRoad,
									block: block,
									allotment: allotment,
									interior: interior,
									reference: reference,
									cellPhone: cellPhone,
									prefix: prefix,
									landline: landline
								}],
								administrativeAddress: [{
									idAffiliation: state.idAffiliation,
									idAddressType: 1,
									idAdministrativeAddress: idAdministrativeAddress,
									idDepartament: administrativeAddress.department.IdDepartament,
									idProvince: administrativeAddress.province.IdProvince,
									idDistrict: administrativeAddress.district.IdDistrict,
									ubiDep: administrativeAddress.department.UbiDep || "",
									ubiPro: administrativeAddress.province.UbiPro || "",
									ubiDis: administrativeAddress.district.UbiDis || "",
									idTypeOfRoad: administrativeAddress.typeOfRoad.IdTypeOfRoad,
									nameOfRoad: administrativeAddress.nameOfRoad || "",
									numberOfRoad: administrativeAddress.numberOfRoad || "",
									plusCode: administrativeAddress.plusCode || "",
									km: administrativeAddress.km || "",
									block: administrativeAddress.block || "",
									allotment: administrativeAddress.allotment || "",
									idInteriorType: administrativeAddress.interiorType ? administrativeAddress.interiorType.IdInteriorType : 0,
									interior: administrativeAddress.interior || "",
									reference: administrativeAddress.reference || "",
									idTypeUrbanHabilitation: administrativeAddress.typeUrbanHabilitation ? administrativeAddress.typeUrbanHabilitation.IdTypeUrbanHabilitation : 0,
									urbanHabilitation: administrativeAddress.urbanHabilitation || "",
									cellPhone: administrativeAddress.cellPhone || "",
									prefix: administrativeAddress.prefix || "",
									landline: administrativeAddress.landline || ""
								}]
							});

						case 13:
							commit("setData", { stateName: "applyToCodeQR", data: applyToCodeQR });
							commit("setBusinessData", data);
							if (this.$isCorresponsalia() && state.corresponsaliaData.header.agent && state.corresponsaliaData.header.agent.IdAgent != 2) {
								commit("setStepNumber", 5);
							} else {
								commit("setStep", true);
							}

						case 16:
						case "end":
							return _context13.stop();
					}
				}
			}, _callee13, this);
		}));

		function saveBusinessData(_x23, _x24) {
			return _ref39.apply(this, arguments);
		}

		return saveBusinessData;
	}(),
	saveCorresponsaliaData: function () {
		var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref40, data) {
			var state = _ref40.state,
			    commit = _ref40.commit;
			return _regeneratorRuntime.wrap(function _callee14$(_context14) {
				while (1) {
					switch (_context14.prev = _context14.next) {
						case 0:
							console.log("setting corresponsalia data: ", data);
							commit("setCorresponsaliaAgent", data.agent);
							commit("setCorresponsaliaAffiliationType", data.affiliationType);

						case 3:
						case "end":
							return _context14.stop();
					}
				}
			}, _callee14, this);
		}));

		function saveCorresponsaliaData(_x25, _x26) {
			return _ref41.apply(this, arguments);
		}

		return saveCorresponsaliaData;
	}(),
	saveBankAccountDataCorresponsalia: function () {
		var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref42, data) {
			var state = _ref42.state,
			    commit = _ref42.commit;
			return _regeneratorRuntime.wrap(function _callee15$(_context15) {
				while (1) {
					switch (_context15.prev = _context15.next) {
						case 0:
							console.log("Setting bank account data corresponsalia: ", data);
							commit("setCorresponsaliaBankAccount", data);
							console.log("end Setting bank account data corresponsalia: ", data);

						case 3:
						case "end":
							return _context15.stop();
					}
				}
			}, _callee15, this);
		}));

		function saveBankAccountDataCorresponsalia(_x27, _x28) {
			return _ref43.apply(this, arguments);
		}

		return saveBankAccountDataCorresponsalia;
	}(),
	saveBusinessSchedule: function () {
		var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref44, data) {
			var state = _ref44.state,
			    commit = _ref44.commit;
			var idSchedule, idBusinessSchedule;
			return _regeneratorRuntime.wrap(function _callee16$(_context16) {
				while (1) {
					switch (_context16.prev = _context16.next) {
						case 0:
							idSchedule = Number(state.businessSchedule.idSchedule);
							idBusinessSchedule = Number(state.businessSchedule.id);

							if (isNaN(idBusinessSchedule)) idBusinessSchedule = 0;
							if (isNaN(idSchedule)) idBusinessSchedule = 0;

							// console.log(data.schedule);

							_context16.next = 6;
							return new AffiliationApi(this.$axios).saveBusinessSchedule({
								idBusinessSchedule: idBusinessSchedule,
								idAffiliation: state.idAffiliation,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								startTime: data.startTime,
								endTime: data.endTime,
								schedules: [{
									idBusinessSchedule: idBusinessSchedule,
									idSchedule: idSchedule,
									monday: data.schedule[0] || 0,
									tuesday: data.schedule[1] || 0,
									wednesday: data.schedule[2] || 0,
									thursday: data.schedule[3] || 0,
									friday: data.schedule[4] || 0,
									saturday: data.schedule[5] || 0,
									sunday: data.schedule[6] || 0
								}]
							});

						case 6:

							commit("setData", { stateName: "businessSchedule", data: data });
							// commit('setStep', true);

						case 7:
						case "end":
							return _context16.stop();
					}
				}
			}, _callee16, this);
		}));

		function saveBusinessSchedule(_x29, _x30) {
			return _ref45.apply(this, arguments);
		}

		return saveBusinessSchedule;
	}(),
	saveInstallationSchedule: function () {
		var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref46, data) {
			var state = _ref46.state,
			    commit = _ref46.commit;
			var idInstallationSchedule;
			return _regeneratorRuntime.wrap(function _callee17$(_context17) {
				while (1) {
					switch (_context17.prev = _context17.next) {
						case 0:
							idInstallationSchedule = Number(state.installationSchedule.id);

							if (isNaN(idInstallationSchedule)) idInstallationSchedule = 0;

							_context17.next = 4;
							return new AffiliationApi(this.$axios).saveInstallationSchedule({
								idInstallationSchedule: idInstallationSchedule,
								idAffiliation: state.idAffiliation,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								name: data.name,
								phone: data.phone,
								paternalName: data.paternalLastname,
								maternalName: data.maternalLastname,
								// idDocumentType: data.documentType.IdDocumentType || null,
								// documentNumber: data.documentNumber,
								email: data.email
							});

						case 4:
							commit("setData", { stateName: "installationSchedule", data: data });
							commit("setStep", true);

						case 6:
						case "end":
							return _context17.stop();
					}
				}
			}, _callee17, this);
		}));

		function saveInstallationSchedule(_x31, _x32) {
			return _ref47.apply(this, arguments);
		}

		return saveInstallationSchedule;
	}(),
	saveBankAccountData: function () {
		var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref48, _ref49) {
			var state = _ref48.state,
			    commit = _ref48.commit,
			    getters = _ref48.getters,
			    dispatch = _ref48.dispatch,
			    rootState = _ref48.rootState;
			var data = _ref49.data;
			var idBankAccountSoles, idBankAccountDolares;
			return _regeneratorRuntime.wrap(function _callee18$(_context18) {
				while (1) {
					switch (_context18.prev = _context18.next) {
						case 0:
							idBankAccountSoles = Number(state.paymentData.idSoles);

							if (isNaN(idBankAccountSoles)) idBankAccountSoles = 0;

							idBankAccountDolares = Number(state.paymentData.idDolares);

							if (isNaN(idBankAccountDolares)) idBankAccountDolares = 0;

							commit("setPaymentData", data);
							// await dispatch('commercialTariff')

							_context18.next = 7;
							return new AffiliationApi(this.$axios).saveBankAccountData({
								idAffiliation: state.idAffiliation,
								idAffiliationProcess: state.idAffiliationProcess,
								bankAccountPEN: [{
									idBankAccount: idBankAccountSoles,
									idAffiliation: state.idAffiliation,
									idCurrency: 1, //data.currencyType,
									idBank: data.bankNameSoles.IdBank,
									idTypeAccountBank: data.accountTypeSoles.IdTypeAccount,
									accountNumber: data.accountNumberSoles
								}],
								bankAccountUSD: [{
									idBankAccount: idBankAccountDolares,
									idAffiliation: state.idAffiliation,
									idCurrency: 2, //data.currencyType,
									idBank: data.bankNameDolares.IdBank,
									idTypeAccountBank: data.accountTypeDolares.IdTypeAccount,
									accountNumber: data.accountNumberDolares
								}]
							});

						case 7:
							if (!getters.isPresential) {
								_context18.next = 10;
								break;
							}

							_context18.next = 10;
							return dispatch("commercialTariff");

						case 10:

							commit("setStep", true);

						case 11:
						case "end":
							return _context18.stop();
					}
				}
			}, _callee18, this);
		}));

		function saveBankAccountData(_x33, _x34) {
			return _ref50.apply(this, arguments);
		}

		return saveBankAccountData;
	}(),
	validateCrmClientOnlyAlquiler: function () {
		var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref51) {
			var state = _ref51.state,
			    commit = _ref51.commit,
			    getters = _ref51.getters,
			    dispatch = _ref51.dispatch,
			    rootState = _ref51.rootState;

			var _rootState$user, username, channelName, subChannelName, _ref53, message;

			return _regeneratorRuntime.wrap(function _callee19$(_context19) {
				while (1) {
					switch (_context19.prev = _context19.next) {
						case 0:
							_rootState$user = rootState.user, username = _rootState$user.username, channelName = _rootState$user.channelName, subChannelName = _rootState$user.subChannelName;
							_context19.next = 3;
							return new AffiliationApi(this.$axios).consultCliente({
								ruc: state.rucValidation.ruc,
								username: username,
								channelName: channelName,
								subChannelName: subChannelName,
								type: "2"
							});

						case 3:
							_ref53 = _context19.sent;
							message = _ref53.content.message;

							commit("setSegmento", message);

						case 6:
						case "end":
							return _context19.stop();
					}
				}
			}, _callee19, this);
		}));

		function validateCrmClientOnlyAlquiler(_x35) {
			return _ref52.apply(this, arguments);
		}

		return validateCrmClientOnlyAlquiler;
	}(),
	saveMembershipRequirements: function () {
		var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref54, data) {
			var state = _ref54.state,
			    commit = _ref54.commit;
			var idAffiliationProcess, idAffiliation, idTransaction, idTransactionBimoneda, currencyTypeBimoneda, sapFiles, url;
			return _regeneratorRuntime.wrap(function _callee20$(_context20) {
				while (1) {
					switch (_context20.prev = _context20.next) {
						case 0:
							idAffiliationProcess = state.idAffiliationProcess, idAffiliation = state.idAffiliation, idTransaction = state.idTransaction, idTransactionBimoneda = state.idTransactionBimoneda, currencyTypeBimoneda = state.currencyTypeBimoneda;
							sapFiles = data.sapFiles, url = data.url;
							_context20.next = 4;
							return new AffiliationApi(this.$axios).saveMembershipRequirement({
								idAffiliation: idAffiliation,
								idAffiliationProcess: idAffiliationProcess,
								urls: data.url
							});

						case 4:
							commit("setData", { stateName: "membershipRequirements", data: data });

							_context20.prev = 5;

							new AffiliationApi(this.$axios).attachImages("", idTransaction, sapFiles, url);
							if (currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) {
								new AffiliationApi(this.$axios).attachImages("", idTransactionBimoneda, sapFiles, url);
							}
							_context20.next = 13;
							break;

						case 10:
							_context20.prev = 10;
							_context20.t0 = _context20["catch"](5);
							throw new WarningError("Ocurrió un error en la subida de archivos. Intente nuevamente por favor.");

						case 13:
							commit("setStep", true);

						case 14:
						case "end":
							return _context20.stop();
					}
				}
			}, _callee20, this, [[5, 10]]);
		}));

		function saveMembershipRequirements(_x36, _x37) {
			return _ref55.apply(this, arguments);
		}

		return saveMembershipRequirements;
	}(),
	saveOsvType: function () {
		var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref56, data) {
			var state = _ref56.state,
			    commit = _ref56.commit,
			    dispatch = _ref56.dispatch;
			return _regeneratorRuntime.wrap(function _callee21$(_context21) {
				while (1) {
					switch (_context21.prev = _context21.next) {
						case 0:
							_context21.next = 2;
							return new AffiliationApi(this.$axios).saveOsvType({
								idAffiliation: state.idAffiliation,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								idTypeOsv: data.osvType,
								commercialCode: data.commercialCode || "0"
							});

						case 2:
							commit("setData", { stateName: "osvType", data: data });
							_context21.next = 5;
							return dispatch("commercialTariff");

						case 5:
							commit("setStep", true);

						case 6:
						case "end":
							return _context21.stop();
					}
				}
			}, _callee21, this);
		}));

		function saveOsvType(_x38, _x39) {
			return _ref57.apply(this, arguments);
		}

		return saveOsvType;
	}(),
	modalityType: function () {
		var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref58, data) {
			var state = _ref58.state,
			    commit = _ref58.commit,
			    dispatch = _ref58.dispatch,
			    rootState = _ref58.rootState;

			var productType, modalityType, currencyType, mcciBimoneda, VENTA, ALQUILER, EXTENDIDA, requestModality, segmento, _segmento;

			return _regeneratorRuntime.wrap(function _callee22$(_context22) {
				while (1) {
					switch (_context22.prev = _context22.next) {
						case 0:
							productType = state.posSelected.pos;
							modalityType = state.typeModalityTitle;
							currencyType = data.currencyType;
							mcciBimoneda = state.mcciForGrifo;

							console.log("Viendo la data de tipo de modalidad: ");
							console.log("productType", productType);
							console.log("modalityType", modalityType);
							console.log("currencyType", currencyType);

							VENTA = 1;
							ALQUILER = 2;
							EXTENDIDA = 3;
							requestModality = {
								type: 0,
								oportunidad: {
									mccNacional: "",
									descMCCNacional: "",
									producto: "",
									subProducto: "",
									tipoAfiliacion: "",
									modalidad: "",
									plan: "",
									afiliacion: ""
								},
								ticket: {
									motivoOrden: "",
									subMotivoOrden: "",
									tipoConexion: "",
									tipoVigenciaEquipo: ""
								}
							};

							if (!(currencyType === currencyTypeEnum.SOLES_Y_DOLARES)) {
								_context22.next = 52;
								break;
							}

							if (!(productType === "POS Inalámbrico" && modalityType === "Alquiler")) {
								_context22.next = 30;
								break;
							}

							_context22.next = 16;
							return dispatch("validateCrmClientOnlyAlquiler");

						case 16:
							segmento = state.segmento;

							requestModality.type = ALQUILER;
							requestModality.oportunidad.mccNacional = corporateSegment.includes(segmento) ? "0100" : "0200";
							requestModality.oportunidad.descMCCNacional = corporateSegment.includes(segmento) ? "MULTICOMERCIO BIMONEDA FIJO" : "Multicomercio";
							requestModality.oportunidad.producto = "BS";
							requestModality.oportunidad.subProducto = "BP";
							requestModality.oportunidad.tipoAfiliacion = "01";
							requestModality.oportunidad.modalidad = "M02";
							requestModality.oportunidad.plan = "P01";
							requestModality.oportunidad.afiliacion = "A03";
							requestModality.ticket.motivoOrden = "INS";
							requestModality.ticket.subMotivoOrden = "INS_0";
							requestModality.ticket.tipoConexion = "T01";
							requestModality.ticket.tipoVigenciaEquipo = "IND";

						case 30:
							if (!(productType === "POS fijo Internet" && modalityType === "Alquiler")) {
								_context22.next = 47;
								break;
							}

							_context22.next = 33;
							return dispatch("validateCrmClientOnlyAlquiler");

						case 33:
							_segmento = state.segmento;

							requestModality.type = ALQUILER;
							requestModality.oportunidad.mccNacional = corporateSegment.includes(_segmento) ? "0100" : "0200";
							requestModality.oportunidad.descMCCNacional = corporateSegment.includes(_segmento) ? "MULTICOMERCIO BIMONEDA FIJO" : "Multicomercio";
							requestModality.oportunidad.producto = "BS";
							requestModality.oportunidad.subProducto = "BP";
							requestModality.oportunidad.tipoAfiliacion = "01";
							requestModality.oportunidad.modalidad = "M02";
							requestModality.oportunidad.plan = "P01";
							requestModality.oportunidad.afiliacion = "A03";
							requestModality.ticket.motivoOrden = "INS";
							requestModality.ticket.subMotivoOrden = "INS_0";
							requestModality.ticket.tipoConexion = "T02";
							requestModality.ticket.tipoVigenciaEquipo = "IND";

						case 47:
							if (productType === "POS Inalámbrico" && modalityType === "Venta Básica") {
								requestModality.type = VENTA;
								requestModality.oportunidad.mccNacional = "6666";
								requestModality.oportunidad.descMCCNacional = "Venta VN";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M01";
								requestModality.oportunidad.plan = "P01";
								requestModality.oportunidad.afiliacion = "A03";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_0";
								requestModality.ticket.tipoConexion = "T01";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							data = requestModality;
							commit("setData", { stateName: "modalityType", data: data });
							_context22.next = 59;
							break;

						case 52:
							if (productType === "POS Inalámbrico" && modalityType === "Alquiler") {
								requestModality.type = ALQUILER;
								requestModality.oportunidad.mccNacional = mcciBimoneda === "5541" ? "9002" : "7777";
								requestModality.oportunidad.descMCCNacional = mcciBimoneda === "5541" ? "DELIVERY REGULAR" : "";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M02";
								requestModality.oportunidad.plan = "P01";
								requestModality.oportunidad.afiliacion = mcciBimoneda === "5541" ? "A04" : "A01";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_0";
								requestModality.ticket.tipoConexion = mcciBimoneda === "5541" ? "T02" : "T01";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							if (productType === "POS fijo Internet" && modalityType === "Alquiler") {
								requestModality.type = ALQUILER;
								requestModality.oportunidad.mccNacional = mcciBimoneda === "5541" ? "9002" : "7777";
								requestModality.oportunidad.descMCCNacional = mcciBimoneda === "5541" ? "DELIVERY REGULAR" : "";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M02";
								requestModality.oportunidad.plan = "P01";
								requestModality.oportunidad.afiliacion = mcciBimoneda === "5541" ? "A04" : "A01";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_0";
								requestModality.ticket.tipoConexion = "T02";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							if (productType === "POS Inalámbrico" && modalityType === "Venta Básica") {
								requestModality.type = VENTA;
								requestModality.oportunidad.mccNacional = "6666";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M01";
								requestModality.oportunidad.plan = "P01";
								requestModality.oportunidad.afiliacion = "A01";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_0";
								requestModality.ticket.tipoConexion = "T01";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							if (productType === "POS Inalámbrico" && modalityType === "Venta Extendida") {
								requestModality.type = EXTENDIDA;
								requestModality.oportunidad.mccNacional = "6668";
								requestModality.oportunidad.descMCCNacional = "Venta Extendida";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M01";
								requestModality.oportunidad.plan = "P02";
								requestModality.oportunidad.afiliacion = "A01";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_MLT";
								requestModality.ticket.tipoConexion = "T01";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							if (productType === "Corresponsalía" && modalityType === "Alquiler") {
								requestModality.type = ALQUILER;
								requestModality.oportunidad.mccNacional = "6666";
								requestModality.oportunidad.producto = "BS";
								requestModality.oportunidad.subProducto = "BP";
								requestModality.oportunidad.tipoAfiliacion = "01";
								requestModality.oportunidad.modalidad = "M01";
								requestModality.oportunidad.plan = "P01";
								requestModality.oportunidad.afiliacion = "A01";
								requestModality.ticket.motivoOrden = "INS";
								requestModality.ticket.subMotivoOrden = "INS_0";
								requestModality.ticket.tipoConexion = "T01";
								requestModality.ticket.tipoVigenciaEquipo = "IND";
							}
							data = requestModality;
							commit("setData", { stateName: "modalityType", data: data });
							// await dispatch('commercialTariff');
							// commit('setStep', true);

						case 59:
						case "end":
							return _context22.stop();
					}
				}
			}, _callee22, this);
		}));

		function modalityType(_x40, _x41) {
			return _ref59.apply(this, arguments);
		}

		return modalityType;
	}(),
	saveAfilliationSummary: function () {
		var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref60, data) {
			var state = _ref60.state,
			    commit = _ref60.commit,
			    dispatch = _ref60.dispatch,
			    getters = _ref60.getters;

			var membershipRequirements, conditionalEquip, conditionalDues, conditionalInstalCostSoles, conditionalInstalCostDolar, maintenancePriceCost, maintenancePriceCostDolar, usePlatformWebCost, isOnHold, isError, platformRecordId, codigogosResult, table, i, resultCrm, initTimeRetries, retries, index, affiliationApi, _affiliationApi;

			return _regeneratorRuntime.wrap(function _callee23$(_context23) {
				while (1) {
					switch (_context23.prev = _context23.next) {
						case 0:
							membershipRequirements = state.membershipRequirements;
							//Clear Data Table

							commit("setDataTableEmpty");
							commit("setInfoTableEmpty");
							//Clear Data Table
							conditionalEquip = getters.isVirtual === true ? 0 : Number(data.equipment.value);
							conditionalDues = getters.isVirtual === true ? 0 : Number(data.dues.value);
							conditionalInstalCostSoles = getters.isVirtual === true ? 0 : Number(data.installationCost);
							conditionalInstalCostDolar = getters.isVirtual === true ? 0 : Number(data.installationCostDolar);
							maintenancePriceCost = 0;
							maintenancePriceCostDolar = 0;
							_context23.t0 = String(state.posSelected.pos);
							_context23.next = _context23.t0 === virtualPosEnum.PAGO_LINK ? 12 : _context23.t0 === virtualPosEnum.PAGO_WEB ? 15 : _context23.t0 === virtualPosEnum.PAGO_APP ? 18 : 21;
							break;

						case 12:
							maintenancePriceCost = 20;
							maintenancePriceCostDolar = 7;
							return _context23.abrupt("break", 22);

						case 15:
							maintenancePriceCost = 50;
							maintenancePriceCostDolar = 15;
							return _context23.abrupt("break", 22);

						case 18:
							maintenancePriceCost = 0;
							maintenancePriceCostDolar = 0;
							return _context23.abrupt("break", 22);

						case 21:
							return _context23.abrupt("break", 22);

						case 22:
							usePlatformWebCost = getters.isVirtual === true && (getters.posName === virtualPosEnum.PAGO_LINK || getters.posName === virtualPosEnum.PAGO_WEB || getters.posName === virtualPosEnum.PAGO_APP) ? Number(data.usePlatformWebCost) : 0;

							if (isNaN(conditionalEquip)) conditionalEquip = 0;
							if (isNaN(conditionalDues)) conditionalDues = 0;
							if (isNaN(conditionalInstalCostSoles)) conditionalInstalCostSoles = 0;
							if (isNaN(conditionalInstalCostDolar)) conditionalInstalCostDolar = 0;
							commit('setData', { stateName: 'afilliationSummary', data: data });
							isOnHold = false;
							isError = false;
							platformRecordId = '';
							codigogosResult = [];
							table = [];

							if (!(state.multiAdress.length > 0)) {
								_context23.next = 98;
								break;
							}

							i = 0;

						case 35:
							if (!(i < state.multiAdress.length)) {
								_context23.next = 93;
								break;
							}

							resultCrm = { arrayResult: [], isFailed: false, inHold: false };
							initTimeRetries = 15000;
							retries = 3;
							index = 0;

						case 40:
							if (!(index <= retries)) {
								_context23.next = 73;
								break;
							}

							if (!(index !== 0 || i !== 0)) {
								_context23.next = 46;
								break;
							}

							console.log("Esperando", initTimeRetries);
							_context23.next = 45;
							return esperar(initTimeRetries);

						case 45:
							console.log("Terminando de Esperar");

						case 46:
							console.log("Intento Nro", i, '--', index);
							_context23.prev = 47;
							_context23.next = 50;
							return dispatch('sendDataMultiAdress', i);

						case 50:
							resultCrm.arrayResult = _context23.sent;

							console.log(">>>>>>>>", resultCrm.arrayResult);
							codigogosResult.push(resultCrm);

							if (!(resultCrm.arrayResult.length > 0 && !resultCrm.arrayResult[0].resultApi.esCodigoEnEspera)) {
								_context23.next = 61;
								break;
							}

							_context23.next = 56;
							return new AffiliationApi(this.$axios).saveAffiliationSummary({
								idAffiliation: state.idAffiliation,
								idAffiliationSummary: 0,
								equiptment: conditionalEquip,
								dues: conditionalDues,
								posNumber: Number(data.posNumber) || '',
								installationCost: conditionalInstalCostSoles,
								installationCostDolar: conditionalInstalCostDolar,
								commerceCodePEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles';
								}) || {
									code: ''
								}).code,
								commerceCodeUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares';
								}) || {
									code: ''
								}).code,
								commerceCodeQrPEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								commerceCodeQrUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								authorizePersonalDataTreatment: data.authorizePersonalDataTreatment,
								isOnHold: isOnHold,
								platformRecordId: platformRecordId,
								maintenancePriceCost: maintenancePriceCost,
								maintenancePriceCostDolar: maintenancePriceCostDolar,
								usePlatformWebCost: usePlatformWebCost,
								nationalMcc: state.commercialTariffResults.length ? state.commercialTariffResults[0].mccn : null
							});

						case 56:
							_context23.next = 58;
							return new AffiliationApi(this.$axios).saveAffiliationWorked({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0,
								noSpecified: false
							});

						case 58:
							if (!(getters.isVirtual !== true)) {
								_context23.next = 61;
								break;
							}

							_context23.next = 61;
							return new AffiliationApi(this.$axios).saveAffiliationPendingCrm({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0
							});

						case 61:
							resultCrm.isFailed = false;
							return _context23.abrupt("break", 73);

						case 65:
							_context23.prev = 65;
							_context23.t1 = _context23["catch"](47);

							console.log(">>>>>>>ERROR SUBIR A CRM", _context23.t1.message);
							initTimeRetries = initTimeRetries * 2;
							resultCrm.isFailed = true;

						case 70:
							index++;
							_context23.next = 40;
							break;

						case 73:
							if (resultCrm.isFailed) {
								_context23.next = 89;
								break;
							}

							if (!(resultCrm.arrayResult.length > 0 && resultCrm.arrayResult[0].resultApi.esCodigoEnEspera)) {
								_context23.next = 89;
								break;
							}

							commit('setOnHold', resultCrm.inHold);
							platformRecordId = resultCrm.arrayResult[0].resultApi.id;
							resultCrm.inHold = true;
							_context23.next = 80;
							return dispatch('saveAffiliationProcess', { isSaved: false });

						case 80:
							affiliationApi = new AffiliationApi(this.$axios);

							commit('setCommerceCodeInProcess', platformRecordId);
							_context23.next = 84;
							return affiliationApi.saveAffiliationSummary({
								idAffiliation: state.idAffiliation,
								idAffiliationSummary: 0,
								equiptment: conditionalEquip,
								dues: conditionalDues,
								posNumber: Number(data.posNumber) || '',
								installationCost: conditionalInstalCostSoles,
								installationCostDolar: conditionalInstalCostDolar,
								commerceCodePEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles';
								}) || {
									code: ''
								}).code,
								commerceCodeUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares';
								}) || {
									code: ''
								}).code,
								commerceCodeQrPEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								commerceCodeQrUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								authorizePersonalDataTreatment: data.authorizePersonalDataTreatment,
								isOnHold: isOnHold,
								platformRecordId: platformRecordId,
								maintenancePriceCost: maintenancePriceCost,
								maintenancePriceCostDolar: maintenancePriceCostDolar,
								usePlatformWebCost: usePlatformWebCost,
								nationalMcc: state.commercialTariffResults.length ? state.commercialTariffResults[0].mccn : null
							});

						case 84:
							_context23.next = 86;
							return new AffiliationApi(this.$axios).saveAffiliationWorked({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0,
								noSpecified: false
							});

						case 86:
							if (!(getters.isVirtual !== true)) {
								_context23.next = 89;
								break;
							}

							_context23.next = 89;
							return new AffiliationApi(this.$axios).saveAffiliationPendingCrm({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0
							});

						case 89:
							commit('functionProccesTable', { resultCommer: resultCrm, indice: i });

						case 90:
							i++;
							_context23.next = 35;
							break;

						case 93:

							console.log(">>>>>>RESULT", codigogosResult);
							commit('setStep', true);
							return _context23.abrupt("return", true);

						case 98:
							_context23.prev = 98;
							_context23.next = 101;
							return dispatch('sendData');

						case 101:
							_context23.next = 103;
							return new AffiliationApi(this.$axios).saveAffiliationSummary({
								idAffiliation: state.idAffiliation,
								idAffiliationSummary: 0,
								equiptment: conditionalEquip,
								dues: conditionalDues,
								posNumber: Number(data.posNumber) || '',
								installationCost: conditionalInstalCostSoles,
								installationCostDolar: conditionalInstalCostDolar,
								commerceCodePEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles';
								}) || {
									code: ''
								}).code,
								commerceCodeUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares';
								}) || {
									code: ''
								}).code,
								commerceCodeQrPEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								commerceCodeQrUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								authorizePersonalDataTreatment: data.authorizePersonalDataTreatment,
								isOnHold: isOnHold,
								platformRecordId: platformRecordId,
								maintenancePriceCost: maintenancePriceCost,
								maintenancePriceCostDolar: maintenancePriceCostDolar,
								usePlatformWebCost: usePlatformWebCost,
								nationalMcc: state.commercialTariffResults.length ? state.commercialTariffResults[0].mccn : null
							});

						case 103:
							_context23.next = 105;
							return new AffiliationApi(this.$axios).saveAffiliationWorked({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0,
								noSpecified: false
							});

						case 105:
							if (!(getters.isVirtual !== true)) {
								_context23.next = 108;
								break;
							}

							_context23.next = 108;
							return new AffiliationApi(this.$axios).saveAffiliationPendingCrm({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0
							});

						case 108:
							return _context23.abrupt("return", true);

						case 111:
							_context23.prev = 111;
							_context23.t2 = _context23["catch"](98);

							if (!(_context23.t2 instanceof OnHoldError)) {
								_context23.next = 120;
								break;
							}

							commit('setOnHold', isOnHold = true);
							platformRecordId = _context23.t2.platformRecordId;
							_context23.next = 118;
							return dispatch('saveAffiliationProcess', { isSaved: false });

						case 118:
							_context23.next = 122;
							break;

						case 120:
							isError = true;
							throw _context23.t2;

						case 122:
							_context23.prev = 122;

							if (!isOnHold) {
								_context23.next = 133;
								break;
							}

							_affiliationApi = new AffiliationApi(this.$axios);

							commit('setCommerceCodeInProcess', platformRecordId);
							_context23.next = 128;
							return _affiliationApi.saveAffiliationSummary({
								idAffiliation: state.idAffiliation,
								idAffiliationSummary: 0,
								equiptment: conditionalEquip,
								dues: conditionalDues,
								posNumber: Number(data.posNumber) || '',
								installationCost: conditionalInstalCostSoles,
								installationCostDolar: conditionalInstalCostDolar,
								commerceCodePEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles';
								}) || {
									code: ''
								}).code,
								commerceCodeUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares';
								}) || {
									code: ''
								}).code,
								commerceCodeQrPEN: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Soles' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								commerceCodeQrUSD: (state.affiliateResults.find(function (ar) {
									return ar.text === 'para Dólares' && ar.isQr === true;
								}) || {
									code: ''
								}).codeQr,
								authorizePersonalDataTreatment: data.authorizePersonalDataTreatment,
								isOnHold: isOnHold,
								platformRecordId: platformRecordId,
								maintenancePriceCost: maintenancePriceCost,
								maintenancePriceCostDolar: maintenancePriceCostDolar,
								usePlatformWebCost: usePlatformWebCost,
								nationalMcc: state.commercialTariffResults.length ? state.commercialTariffResults[0].mccn : null
							});

						case 128:
							_context23.next = 130;
							return new AffiliationApi(this.$axios).saveAffiliationWorked({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0,
								noSpecified: false
							});

						case 130:
							if (!(getters.isVirtual !== true)) {
								_context23.next = 133;
								break;
							}

							_context23.next = 133;
							return new AffiliationApi(this.$axios).saveAffiliationPendingCrm({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0
							});

						case 133:
							if (!isError) commit('setStep', true);

							if (!state.onHold) {
								_context23.next = 136;
								break;
							}

							return _context23.abrupt("return", true);

						case 136:
							return _context23.finish(122);

						case 137:
						case "end":
							return _context23.stop();
					}
				}
			}, _callee23, this, [[47, 65], [98, 111, 122, 137]]);
		}));

		function saveAfilliationSummary(_x42, _x43) {
			return _ref61.apply(this, arguments);
		}

		return saveAfilliationSummary;
	}(),
	addCommerceCodeFile: function () {
		var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref62, data) {
			var state = _ref62.state,
			    commit = _ref62.commit,
			    dispatch = _ref62.dispatch,
			    getters = _ref62.getters;

			var commerceCode, idTransaction, idTransactionBimoneda, currencyTypeBimoneda, affiliationApi, _commerceCode, _idTransaction, _idTransactionBimoneda, _currencyTypeBimoneda, _affiliationApi2, isMulti, reqSoles, reqDolares;

			return _regeneratorRuntime.wrap(function _callee24$(_context24) {
				while (1) {
					switch (_context24.prev = _context24.next) {
						case 0:
							console.log("addComercodeFile 01");

							if (!(state.multiAdress.length == 0)) {
								_context24.next = 19;
								break;
							}

							_context24.prev = 2;
							commerceCode = state.commerceCode, idTransaction = state.idTransaction, idTransactionBimoneda = state.idTransactionBimoneda, currencyTypeBimoneda = state.currencyTypeBimoneda;

							console.log("addComercodeFile 02", commerceCode);
							affiliationApi = new AffiliationApi(this.$axios);
							_context24.next = 8;
							return affiliationApi.addCommerceCodeFile(idTransaction, commerceCode[0].code);

						case 8:
							console.log("addComercodeFile 03");

							if (!(currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES)) {
								_context24.next = 12;
								break;
							}

							_context24.next = 12;
							return affiliationApi.addCommerceCodeFile(idTransactionBimoneda, commerceCode[1].code);

						case 12:
							_context24.next = 17;
							break;

						case 14:
							_context24.prev = 14;
							_context24.t0 = _context24["catch"](2);
							throw new WarningError("Ocurrió un error en la subida de archivos. Intente nuevamente por favor.");

						case 17:
							_context24.next = 38;
							break;

						case 19:
							_context24.prev = 19;
							_commerceCode = state.commerceCode, _idTransaction = state.idTransaction, _idTransactionBimoneda = state.idTransactionBimoneda, _currencyTypeBimoneda = state.currencyTypeBimoneda;
							_affiliationApi2 = new AffiliationApi(this.$axios);
							isMulti = 1;

							console.log(">>>>DATA", state.dataTable);
							reqSoles = mapperMultiAdressCodes(state.dataTable, 'soles');
							reqDolares = mapperMultiAdressCodes(state.dataTable, 'dolares');

							console.log(">>>>", reqSoles);
							console.log(">>>>", reqDolares);
							_context24.next = 30;
							return _affiliationApi2.addCommerceCodeFile(_idTransaction, "--", isMulti, reqSoles);

						case 30:
							if (!(_currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES)) {
								_context24.next = 33;
								break;
							}

							_context24.next = 33;
							return _affiliationApi2.addCommerceCodeFile(_idTransactionBimoneda, null, isMulti, reqDolares);

						case 33:
							_context24.next = 38;
							break;

						case 35:
							_context24.prev = 35;
							_context24.t1 = _context24["catch"](19);
							throw new WarningError("Ocurrió un error en la subida de archivos. Intente nuevamente por favor.");

						case 38:
						case "end":
							return _context24.stop();
					}
				}
			}, _callee24, this, [[2, 14], [19, 35]]);
		}));

		function addCommerceCodeFile(_x44, _x45) {
			return _ref63.apply(this, arguments);
		}

		return addCommerceCodeFile;
	}(),

	//todo: error send data
	sendData: function () {
		var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref64) {
			var state = _ref64.state,
			    commit = _ref64.commit,
			    dispatch = _ref64.dispatch,
			    getters = _ref64.getters,
			    rootState = _ref64.rootState;

			var commercialTariffResults, membershipRequirements, idTransactionBimoneda, affiliationApi, commercialTariffResultSoles, commercialTariffResultDolares, isNotBimoney, isVirtual, isPresential, commerceCodes, requestSoles, requestDolares, mapCommerce, generateCommerceCodeSoles, _mapCommerce, generateCommerceCodeDolares, _mapCommerce2, _generateCommerceCodeSoles, _mapCommerce3, _generateCommerceCodeDolares;

			return _regeneratorRuntime.wrap(function _callee25$(_context25) {
				while (1) {
					switch (_context25.prev = _context25.next) {
						case 0:
							commercialTariffResults = state.commercialTariffResults, membershipRequirements = state.membershipRequirements, idTransactionBimoneda = state.idTransactionBimoneda;
							affiliationApi = new AffiliationApi(this.$axios);
							commercialTariffResultSoles = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.SOLES;
							});
							commercialTariffResultDolares = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.DOLARES;
							});
							isNotBimoney = commercialTariffResults.length === 1;
							isVirtual = getters.isVirtual;
							isPresential = getters.isPresential;
							commerceCodes = [];

							console.log("form ->>", state.comission);
							requestSoles = {
								state: state,
								commercialTariffResult: commercialTariffResultSoles,
								isNotBimoney: isNotBimoney,
								isVirtual: isVirtual,
								isPresential: isPresential,
								user: rootState.user,
								masterData: rootState["master-data"],
								isMulti: false,
								requestModalityBimoneda: {
									motivoOrden: "",
									subMotivoOrden: ""
								},
								idTransactionBimoneda: null
							};

							console.log("sendata 001");
							requestDolares = {
								state: state,
								commercialTariffResult: commercialTariffResultDolares,
								isNotBimoney: isNotBimoney,
								isVirtual: isVirtual,
								isPresential: isPresential,
								user: rootState.user,
								masterData: rootState["master-data"],
								isMulti: false,
								requestModalityBimoneda: {
									motivoOrden: "",
									subMotivoOrden: ""
								},
								idTransactionBimoneda: idTransactionBimoneda
							};

							console.log("sendata 002");
							console.log("Currency type", state);

							if (!(state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES)) {
								_context25.next = 39;
								break;
							}

							if (!((isVirtual || isPresential) && commercialTariffResultSoles)) {
								_context25.next = 27;
								break;
							}

							requestSoles.requestModalityBimoneda.motivoOrden = "INS", requestSoles.requestModalityBimoneda.subMotivoOrden = "INS_MLT";
							requestSoles.isMulti = true;
							console.log("Mapeo 001");
							mapCommerce = newMapRequestGenerateCommerceCode(requestSoles);
							_context25.next = 22;
							return affiliationApi.generateCommerceCode(mapCommerce);

						case 22:
							generateCommerceCodeSoles = _context25.sent;
							_context25.next = 25;
							return dispatch("checkGenerateCommerceCodeResult", generateCommerceCodeSoles);

						case 25:

							commerceCodes.push({
								code: generateCommerceCodeSoles.codigoComercio,
								text: "para Soles"
							});
							if (state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) commit("setCommerceCodePadre", generateCommerceCodeSoles.codigoComercio);

						case 27:
							if (!((isVirtual || isPresential) && commercialTariffResultDolares)) {
								_context25.next = 37;
								break;
							}

							requestDolares.requestModalityBimoneda.motivoOrden = "RGS", requestDolares.requestModalityBimoneda.subMotivoOrden = "RGS_MLT";
							_mapCommerce = newMapRequestGenerateCommerceCode(requestDolares);
							_context25.next = 32;
							return affiliationApi.generateCommerceCode(_mapCommerce);

						case 32:
							generateCommerceCodeDolares = _context25.sent;
							_context25.next = 35;
							return dispatch("checkGenerateCommerceCodeResult", generateCommerceCodeDolares);

						case 35:
							commit("setCommerceCodePadre", "");
							commerceCodes.push({
								code: generateCommerceCodeDolares.codigoComercio,
								text: "para Dólares"
							});

						case 37:
							_context25.next = 61;
							break;

						case 39:
							console.log("Mapeo 002");

							if (!((isVirtual || isPresential) && commercialTariffResultSoles)) {
								_context25.next = 50;
								break;
							}

							console.log("Mapeo 002.1");
							_mapCommerce2 = newMapRequestGenerateCommerceCode(requestSoles);
							_context25.next = 45;
							return affiliationApi.generateCommerceCode(_mapCommerce2);

						case 45:
							_generateCommerceCodeSoles = _context25.sent;
							_context25.next = 48;
							return dispatch("checkGenerateCommerceCodeResult", _generateCommerceCodeSoles);

						case 48:

							commerceCodes.push({
								code: _generateCommerceCodeSoles.codigoComercio,
								text: "para Soles"
							});
							if (state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) commit("setCommerceCodePadre", _generateCommerceCodeSoles.codigoComercio);

						case 50:
							if (!((isVirtual || isPresential) && commercialTariffResultDolares)) {
								_context25.next = 61;
								break;
							}

							console.log("Mapeo 002.2");
							console.log("Mapeo 002.2", requestDolares);
							_mapCommerce3 = newMapRequestGenerateCommerceCode(requestDolares);
							_context25.next = 56;
							return affiliationApi.generateCommerceCode(_mapCommerce3);

						case 56:
							_generateCommerceCodeDolares = _context25.sent;
							_context25.next = 59;
							return dispatch("checkGenerateCommerceCodeResult", _generateCommerceCodeDolares);

						case 59:
							commit("setCommerceCodePadre", "");
							commerceCodes.push({
								code: _generateCommerceCodeDolares.codigoComercio,
								text: "para Dólares"
							});

						case 61:
							console.log("Fin send data");
							if (isVirtual || isPresential) {
								commit("setCommerceCode", commerceCodes);
								commit("setAffiliateResults", commerceCodes);
							}

							// Se guardaran los archivos en la base de datos
							// try {
							// 	await affiliationApi.attachImages(String(state.commerceCode[0].code), membershipRequirements.sapFiles, membershipRequirements.url);
							// } catch (error) {
							// 	throw new WarningError('Ocurrió un error en la subida de archivos. Intente nuevamente por favor.');
							// }

						case 63:
						case "end":
							return _context25.stop();
					}
				}
			}, _callee25, this);
		}));

		function sendData(_x46) {
			return _ref65.apply(this, arguments);
		}

		return sendData;
	}(),
	sendDataBimoneda: function () {
		var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref66) {
			var state = _ref66.state,
			    commit = _ref66.commit,
			    dispatch = _ref66.dispatch,
			    getters = _ref66.getters,
			    rootState = _ref66.rootState;
			var affiliationApi, resultCrmClient, idTransaction, internalStatusCode, internalStatusDescription, requestComision;
			return _regeneratorRuntime.wrap(function _callee26$(_context26) {
				while (1) {
					switch (_context26.prev = _context26.next) {
						case 0:
							affiliationApi = new AffiliationApi(this.$axios);

							//segunda validacion en bimoneda

							//* 1.- obtener nuevo idTransaccion

							_context26.next = 3;
							return affiliationApi.validateCrmClient(state.rucValidation.ruc);

						case 3:
							resultCrmClient = _context26.sent;
							idTransaction = resultCrmClient.idTransaction, internalStatusCode = resultCrmClient.internalStatusCode, internalStatusDescription = resultCrmClient.internalStatusDescription;

							commit("setIdTransactionBimoneda", idTransaction);
							// if (!internalStatusCode !== '0000' )
							//   throw new ConflictError("Error en validacion CrmClient  flujo bimoneda. ",internalStatusDescription);
							console.log("1.- obtener nuevo idTransaccion");

							//* 2.- Enviando datos del representante
							_context26.next = 9;
							return new AffiliationApi(this.$axios).validateCrmContact({
								requestId: idTransaction,
								ruc: state.rucValidation.ruc,
								documentNumber: state.legalRepresentativeData.documentNumber,
								firstname: state.legalRepresentativeData.firstName,
								lastname: state.legalRepresentativeData.paternalName + " " + state.legalRepresentativeData.maternalName
							});

						case 9:

							console.log("2.- Enviando datos del representante");
							// if (!resultCrmContact.internalStatusCode !== '0000' )
							// throw new ConflictError("Error en validacion CrmClient  flujo bimoneda. ",resultCrmContact.internalStatusDescription);

							//* 3.- Enviando comisiones
							requestComision = {
								audit: {
									appId: "PCRM001V1",
									usuario: "",
									ipServidor: "",
									transaccionId: state.idTransactionBimoneda,
									origen: ""
								},
								obtenerComisionesRequest: {
									cliente: {
										ruc: state.rucValidation.ruc,
										oportunidad: {
											producto: "",
											subProducto: "",
											mccInternacional: state.businessData.commerceData.nationalMcc,
											plataforma: ""
										}
									}
								}
							};
							_context26.next = 13;
							return dispatch("consultComision", requestComision);

						case 13:
							// if (codigo !== "0000")
							//   if (!mensaje) {
							//     throw new WarningError("El servicio no se encuentra disponible.");
							//   } else {
							//     throw new WarningError(mensaje);
							//   }
							console.log("3.- Enviando comisiones");

							//* 4.- Enviando crm opportunity
							_context26.next = 16;
							return new AffiliationApi(this.$axios).validateCrmOpportunity({
								requestId: idTransaction,
								documentNumber: state.legalRepresentativeData.documentNumber,
								email: state.legalRepresentativeData.email,
								firstname: state.legalRepresentativeData.firstName,
								lastname: state.legalRepresentativeData.paternalName + " " + state.legalRepresentativeData.maternalName,
								legalname: state.legalRepresentativeData.paternalName + " " + state.legalRepresentativeData.maternalName + " " + state.legalRepresentativeData.firstName,
								ruc: state.rucValidation.ruc,
								phoneMobile: state.businessData.commercialAddress.cellPhone,
								phoneWork: state.businessData.commercialAddress.prefix + state.businessData.commercialAddress.landline
							});

						case 16:
							console.log("4.- Enviando crm opportunity ");
							// if (!resultCrmOpportunity.internalStatusCode !== '0000' )
							// throw new ConflictError("Error en validacion CrmClient  flujo bimoneda. ",resultCrmContact.internalStatusDescription);

							//*5 Validar cuenta bancaria
							//? Esto se realiza en componente bank-account-data

							console.log("Revisando todos los datos");

						case 18:
						case "end":
							return _context26.stop();
					}
				}
			}, _callee26, this);
		}));

		function sendDataBimoneda(_x47) {
			return _ref67.apply(this, arguments);
		}

		return sendDataBimoneda;
	}(),
	sendDataPresencial: function () {
		var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref68, captchaCode) {
			var state = _ref68.state,
			    getters = _ref68.getters,
			    commit = _ref68.commit,
			    rootState = _ref68.rootState;
			var username, form, commercialTariffResults, num_incidencia, membershipRequirements, affiliationApi, affiliateResultSoles, affiliateResultDolares, results, commerceCodes, commercialTariffResultSoles, commercialTariffResultDolares, resend;
			return _regeneratorRuntime.wrap(function _callee27$(_context27) {
				while (1) {
					switch (_context27.prev = _context27.next) {
						case 0:
							username = rootState.user.username;
							form = state;
							commercialTariffResults = form.commercialTariffResults, num_incidencia = form.num_incidencia, membershipRequirements = form.membershipRequirements;
							affiliationApi = new AffiliationApi(this.$axios);

							if (!(!commercialTariffResults || !commercialTariffResults.length)) {
								_context27.next = 6;
								break;
							}

							throw new ConflictError("No hay tarifas comerciales");

						case 6:
							affiliateResultSoles = void 0, affiliateResultDolares = void 0, results = [], commerceCodes = [];
							commercialTariffResultSoles = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.SOLES;
							});
							commercialTariffResultDolares = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.DOLARES;
							});
							resend = void 0;

							// SOLES

							if (!commercialTariffResultSoles) {
								_context27.next = 16;
								break;
							}

							_context27.next = 13;
							return affiliationApi.affiliate(mapRequestAffiliation({
								form: form,
								commercialTariffResult: commercialTariffResultSoles,
								// preliminaryCheckResult: preliminaryCheckResultSoles,
								isNotBimoney: commercialTariffResults.length === 1,
								username: username,
								getters: getters
							}), resend);

						case 13:
							affiliateResultSoles = _context27.sent;

							results.push(affiliateResultSoles);
							commerceCodes.push({ code: affiliateResultSoles, text: "para Soles" });

						case 16:
							if (!commercialTariffResultDolares) {
								_context27.next = 23;
								break;
							}

							if (affiliateResultSoles) resend = true;
							// preliminaryCheckResultDolares = commercialTariffResultDolares.preliminaryCheckResult
							_context27.next = 20;
							return affiliationApi.affiliate(mapRequestAffiliation({
								form: form,
								commercialTariffResult: commercialTariffResultDolares,
								// preliminaryCheckResult: preliminaryCheckResultDolares,
								previousCommerceCode: affiliateResultSoles ? affiliateResultSoles.result : null,
								isNotBimoney: commercialTariffResults.length === 1,
								username: username,
								getters: getters
							}), resend);

						case 20:
							affiliateResultDolares = _context27.sent;

							results.push(affiliateResultDolares);
							commerceCodes.push({
								code: affiliateResultDolares.result,
								text: "para Dólares"
							});

						case 23:
							_context27.next = 25;
							return affiliationApi.attachImages(form.idTransaction, membershipRequirements.sapFiles);

						case 25:
							// await affiliationApi.attachImages(num_incidencia, membershipRequirements.sapFiles)

							commit("setCommerceCode", commerceCodes);
							commit("setAffiliateResults", results);

						case 27:
						case "end":
							return _context27.stop();
					}
				}
			}, _callee27, this);
		}));

		function sendDataPresencial(_x48, _x49) {
			return _ref69.apply(this, arguments);
		}

		return sendDataPresencial;
	}(),
	sendDataVirtual: function () {
		var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref70, captchaCode) {
			var state = _ref70.state,
			    commit = _ref70.commit,
			    rootState = _ref70.rootState;
			var username, response, text;
			return _regeneratorRuntime.wrap(function _callee28$(_context28) {
				while (1) {
					switch (_context28.prev = _context28.next) {
						case 0:
							username = rootState.user.username;
							_context28.next = 3;
							return new AffiliationApi(this.$axios).affiliateVirtual(mapRequestVirtualAffiliation(state, username), captchaCode);

						case 3:
							response = _context28.sent;
							text = state.paymentData.currencyType == currencyTypeEnum.SOLES ? "para Soles" : "para Dólares";


							commit("setCommerceCode", [{ code: response, text: text }]);
							commit("setAffiliateResults", [response]);

						case 7:
						case "end":
							return _context28.stop();
					}
				}
			}, _callee28, this);
		}));

		function sendDataVirtual(_x50, _x51) {
			return _ref71.apply(this, arguments);
		}

		return sendDataVirtual;
	}(),
	saveAffiliationWorked: function saveAffiliationWorked(_ref72, _ref73) {
		var state = _ref72.state,
		    dispatch = _ref72.dispatch,
		    rootGetters = _ref72.rootGetters;
		var idReason = _ref73.idReason,
		    noSpecified = _ref73.noSpecified;

		return new AffiliationApi(this.$axios).saveAffiliationWorked({
			idAffiliation: state.idAffiliation,
			idReason: idReason,
			steps: state.step,
			noSpecified: noSpecified
		});
	},
	saveAffiliationProcess: function saveAffiliationProcess(_ref74, _ref75) {
		var state = _ref74.state,
		    dispatch = _ref74.dispatch,
		    rootGetters = _ref74.rootGetters;
		var isSaved = _ref75.isSaved;
		var idAffiliation = state.idAffiliation,
		    idAffiliationProcess = state.idAffiliationProcess,
		    step = state.step,
		    idTransaction = state.idTransaction,
		    validateCrmClientData = state.validateCrmClientData,
		    rucValidation = state.rucValidation,
		    paymentData = state.paymentData;

		var CrmSic = "";
		var CrmDesc = "";
		if (validateCrmClientData) {
			CrmSic = validateCrmClientData.SIC;
			CrmDesc = validateCrmClientData.Desc;
		}
		var LastRequestToSunatDate = rucValidation.consultDate;
		var AlternativeAccountNumberSoles = paymentData.alternativeAccountNumberSoles ? paymentData.alternativeAccountNumberSoles : "";
		var AlternativeAccountNumberDolares = paymentData.alternativeAccountNumberDolares ? paymentData.alternativeAccountNumberDolares : "";

		var api = new AffiliationApi(this.$axios);
		var stringState = _JSON$stringify(state);
		var tempState = JSON.parse(stringState);

		if (tempState.membershipRequirements && tempState.membershipRequirements.sapFiles.length) {
			tempState.membershipRequirements.sapFiles = [];
		}
		console.log(tempState);
		var StateStr = encryptText(_JSON$stringify(tempState));
		//Elimina campo de archivos en base64

		var AffiliationProcessDto = {
			idAffiliation: idAffiliation,
			steps: step,
			idTransaction: idTransaction,
			isSaved: isSaved,
			CrmSic: CrmSic,
			CrmDesc: CrmDesc,
			LastRequestToSunatDate: LastRequestToSunatDate,
			AlternativeAccountNumberSoles: AlternativeAccountNumberSoles,
			AlternativeAccountNumberDolares: AlternativeAccountNumberDolares,
			StateStr: StateStr
		};
		if (state.idAffiliationProcess && state.idAffiliationProcess > 0) {
			AffiliationProcessDto.IdAffiliationProcess = state.idAffiliationProcess;
		}
		return api.saveAffiliationInProcess(AffiliationProcessDto);
	},
	saveVirtualCommerceData: function () {
		var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref76, data) {
			var state = _ref76.state,
			    commit = _ref76.commit,
			    getters = _ref76.getters;
			return _regeneratorRuntime.wrap(function _callee29$(_context29) {
				while (1) {
					switch (_context29.prev = _context29.next) {
						case 0:
							if (getters.isPagoWeb) {
								commit("setWebSite", {
									url: data.webSiteUrl,
									developer: {
										company: data.enterpriseName,
										developmentType: data.idTypeOfDevelopment,
										email: data.contactEmail,
										fullname: data.contactName,
										phone: data.contactCellphone
									},
									integration: {
										paymentForm: "102"
									}
								});
							} else {
								commit("setApp", {
									link: data.linkAPP,
									name: data.nameAPP,
									platform: data.idPlatform,
									developer: {
										company: data.enterpriseName,
										developmentType: data.idTypeOfDevelopment,
										email: data.contactEmail,
										fullname: data.contactName,
										phone: data.contactCellphone
									},
									integration: {
										paymentForm: "102"
									}
								});
							}

							_context29.next = 3;
							return new AffiliationApi(this.$axios).saveVirtualCommerceData({
								idAffiliation: state.idAffiliation || 0,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								idVirtualCommerceData: state.virtual.app.id || 0,
								idTypeOfDevelopment: data.idTypeOfDevelopment || 0,
								nameAPP: data.nameAPP || "",
								linkAPP: data.linkAPP || data.webSiteUrl || "",
								idPlatform: data.idPlatform || 0,
								developerName: data.developerName || "",
								enterpriseName: data.enterpriseName || "",
								contactName: data.contactName || "",
								email: data.contactEmail || "",
								contactCellphone: data.contactCellphone || "",
								steps: state.step
							});

						case 3:
							commit("setData", { stateName: "vitualCommerceData", data: data });
							commit("setStep", true);

						case 5:
						case "end":
							return _context29.stop();
					}
				}
			}, _callee29, this);
		}));

		function saveVirtualCommerceData(_x52, _x53) {
			return _ref77.apply(this, arguments);
		}

		return saveVirtualCommerceData;
	}(),
	saveStepsAdministrativePlatform: function () {
		var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_ref78, data) {
			var state = _ref78.state,
			    commit = _ref78.commit,
			    dispatch = _ref78.dispatch;
			return _regeneratorRuntime.wrap(function _callee30$(_context30) {
				while (1) {
					switch (_context30.prev = _context30.next) {
						case 0:
							_context30.next = 2;
							return new AffiliationApi(this.$axios).saveStepsAdministrativePlatform({
								idAdministrativePlatform: state.virtual.user.id || 0,
								idAffiliation: state.idAffiliation || 0,
								idAffiliationProcess: state.idAffiliationProcess || 0,
								usingLegalRepresentativeData: data.usingLegalRepresentativeData,
								firstlastName: data.firstlastName || "",
								email: data.email || "",
								cellPhone: data.cellPhone || ""
							});

						case 2:

							commit("setData", { stateName: "administrativePlatform", data: data });
							_context30.next = 5;
							return dispatch("commercialTariff");

						case 5:
							commit("setStep", true);

						case 6:
						case "end":
							return _context30.stop();
					}
				}
			}, _callee30, this);
		}));

		function saveStepsAdministrativePlatform(_x54, _x55) {
			return _ref79.apply(this, arguments);
		}

		return saveStepsAdministrativePlatform;
	}(),
	loadFromAffiliationProcess: function () {
		var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(_ref80, _ref81) {
			var state = _ref80.state,
			    rootState = _ref80.rootState,
			    commit = _ref80.commit,
			    dispatch = _ref80.dispatch;
			var idAffiliation = _ref81.idAffiliation,
			    idAffiliationProcess = _ref81.idAffiliationProcess;

			var affiliationProcess, paymentDataSoles, paymentDataDolares, StateStr, TypeAccountSoles, TypeAccountDolares, _state$paymentData, bankNameSoles, bankNameDolares;

			return _regeneratorRuntime.wrap(function _callee31$(_context31) {
				while (1) {
					switch (_context31.prev = _context31.next) {
						case 0:
							if (idAffiliation && idAffiliationProcess) {
								_context31.next = 2;
								break;
							}

							return _context31.abrupt("return");

						case 2:

							idAffiliation = Number(idAffiliation);
							idAffiliationProcess = Number(idAffiliationProcess);

							_context31.next = 6;
							return new AffiliationApi(this.$axios).findAffiliationProcessForTable({ idAffiliationProcess: idAffiliationProcess, idAffiliation: idAffiliation });

						case 6:
							affiliationProcess = _context31.sent;
							paymentDataSoles = {}, paymentDataDolares = {};
							StateStr = affiliationProcess.StateStr ? JSON.parse(decryptText(affiliationProcess.StateStr)) : null;

							commit("setData", { stateName: "tipoEquipo", data: StateStr.tipoEquipo });

							if (Array.isArray(affiliationProcess.BankAccounts) && affiliationProcess.BankAccounts.length) {
								paymentDataSoles = affiliationProcess.BankAccounts.find(function (ba) {
									return ba.IdCurrency === 1;
								}) || {}; /** Soles */
								paymentDataDolares = affiliationProcess.BankAccounts.find(function (ba) {
									return ba.IdCurrency === 2;
								}) || {}; /** Dolares */
							}

							if (!paymentDataSoles.IdBank) {
								_context31.next = 17;
								break;
							}

							_context31.next = 14;
							return new MasterApi(this.$axios).findAllTypeAccountByBank({
								idBank: paymentDataSoles.IdBank
							});

						case 14:
							_context31.t0 = _context31.sent;
							_context31.next = 18;
							break;

						case 17:
							_context31.t0 = null;

						case 18:
							TypeAccountSoles = _context31.t0;

							if (!paymentDataDolares.IdBank) {
								_context31.next = 25;
								break;
							}

							_context31.next = 22;
							return new MasterApi(this.$axios).findAllTypeAccountByBank({
								idBank: paymentDataDolares.IdBank
							});

						case 22:
							_context31.t1 = _context31.sent;
							_context31.next = 26;
							break;

						case 25:
							_context31.t1 = null;

						case 26:
							TypeAccountDolares = _context31.t1;

							console.log("payment_data 02", state.paymentData);
							commit("setFromAffiliationInProcess", {
								affiliationProcess: affiliationProcess,
								masterData: rootState["master-data"]
							});
							console.log("*********payment_data 03", state.paymentData);
							state.paymentData.accountTypeSoles.Name = TypeAccountSoles ? TypeAccountSoles.find(function (ta) {
								return ta.IdTypeAccount === paymentDataSoles.IdTypeAccount;
							}).Name : null;
							state.paymentData.accountTypeDolares.Name = TypeAccountDolares ? TypeAccountDolares.find(function (ta) {
								return ta.IdTypeAccount === paymentDataDolares.IdTypeAccount;
							}).Name : null;
							//Añadir llamada de mutation
							if (!state.ModalityTitle) {
								console.log("Setting modalityTitle");
								console.log(StateStr.typeModalityTitle);
								commit('setTypeModalityTitle', StateStr.typeModalityTitle);
							}
							console.log("payment_data", state.paymentData);
							dispatch("modalityType",
							// modalityType
							state.paymentData);
							commit("setRucConsultDate", affiliationProcess);
							_state$paymentData = state.paymentData, bankNameSoles = _state$paymentData.bankNameSoles, bankNameDolares = _state$paymentData.bankNameDolares;
							_context31.next = 39;
							return _Promise.all([!bankNameSoles.IdBank ? _Promise.resolve() : dispatch("master-data/affiliation-in-process/loadAccountTypesSoles", bankNameSoles.IdBank, { root: true }), !bankNameDolares.IdBank ? _Promise.resolve() : dispatch("master-data/affiliation-in-process/loadAccountTypesDolares", bankNameDolares.IdBank, { root: true })]);

						case 39:
							if (!(state.registerStatus || state.onHold)) {
								_context31.next = 51;
								break;
							}

							commit("setStep", true);

							_context31.t2 = state.registerStatus;
							_context31.next = _context31.t2 === "A" ? 44 : _context31.t2 === "R" ? 48 : 51;
							break;

						case 44:
							_context31.next = 46;
							return new AffiliationApi(this.$axios).saveAffiliationWorked({
								idAffiliation: state.idAffiliation,
								idReason: 0,
								steps: 0,
								noSpecified: false
							});

						case 46:

							// dispatch("sendSummary")
							dispatch("sendSummaryV2").then(console.log).catch(console.log);
							return _context31.abrupt("break", 51);

						case 48:
							_context31.next = 50;
							return dispatch("saveAffiliationWorked", {
								idReason: 0,
								noSpecified: false
							});

						case 50:
							return _context31.abrupt("break", 51);

						case 51:
							_context31.next = 53;
							return dispatch("loadUbigeoData");

						case 53:
							if (!state.ubigeo) {
								_context31.next = 57;
								break;
							}

							calculateUbigeo(state, "commercialAddress");
							_context31.next = 57;
							return dispatch("commercialTariff");

						case 57:
							if (state.paymentData.currencyType) {
								commit("setRentalPrice");
							}
							commit("setData", { stateName: "corresponsaliaData", data: StateStr.corresponsaliaData });
							commit("setData", { stateName: "businessData", data: StateStr.businessData });
							commit("setMultiAdress", StateStr.multiAdress || []);
							commit("setinMultiAdressisSameDirection", StateStr.inMultiAdressisSameDirection || true);

						case 62:
						case "end":
							return _context31.stop();
					}
				}
			}, _callee31, this);
		}));

		function loadFromAffiliationProcess(_x56, _x57) {
			return _ref82.apply(this, arguments);
		}

		return loadFromAffiliationProcess;
	}(),
	loadUbigeoData: function () {
		var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(_ref83) {
			var state = _ref83.state,
			    commit = _ref83.commit,
			    dispatch = _ref83.dispatch;

			var ROOT, _state$businessData, commercialAddress, administrativeAddress, departmentId, provinceId, districtId, addressPropertyType, provinces, districts, _departmentId, _provinceId, _districtId, _addressPropertyType, _provinces, _districts;

			return _regeneratorRuntime.wrap(function _callee32$(_context32) {
				while (1) {
					switch (_context32.prev = _context32.next) {
						case 0:
							ROOT = { root: true };
							_state$businessData = state.businessData, commercialAddress = _state$businessData.commercialAddress, administrativeAddress = _state$businessData.administrativeAddress;

							if (!(commercialAddress.province.IdProvince && commercialAddress.department.IdDepartament)) {
								_context32.next = 21;
								break;
							}

							departmentId = commercialAddress.department.IdDepartament;
							provinceId = commercialAddress.province.IdProvince;
							districtId = commercialAddress.district.IdDistrict;
							addressPropertyType = "commercialAddress";
							_context32.next = 9;
							return dispatch("master-data/getProvince", { departmentId: departmentId }, ROOT);

						case 9:
							provinces = _context32.sent;
							_context32.next = 12;
							return dispatch("master-data/affiliation-in-process/setProvinces", { addressPropertyType: addressPropertyType, provinces: provinces }, ROOT);

						case 12:
							commit("setProvince", {
								addressPropertyType: addressPropertyType,
								province: provinces.find(function (p) {
									return p.IdProvince === provinceId;
								}) || {
									IdProvince: provinceId
								}
							});

							if (!commercialAddress.district.IdDistrict) {
								_context32.next = 21;
								break;
							}

							_context32.next = 16;
							return dispatch("master-data/getDistrict", { departmentId: departmentId, provinceId: provinceId }, ROOT);

						case 16:
							districts = _context32.sent;
							_context32.next = 19;
							return dispatch("master-data/affiliation-in-process/setDistricts", { addressPropertyType: addressPropertyType, districts: districts }, ROOT);

						case 19:
							commit("setDistrict", {
								addressPropertyType: addressPropertyType,
								district: districts.find(function (p) {
									return p.IdDistrict === districtId;
								}) || {
									IdDistrict: districtId
								}
							});

							commit("recalculateUbigeo");

						case 21:
							if (!(administrativeAddress.province.IdProvince && administrativeAddress.department.IdDepartament)) {
								_context32.next = 39;
								break;
							}

							_departmentId = administrativeAddress.department.IdDepartament;
							_provinceId = administrativeAddress.province.IdProvince;
							_districtId = administrativeAddress.district.IdDistrict;
							_addressPropertyType = "administrativeAddress";
							_context32.next = 28;
							return dispatch("master-data/getProvince", { departmentId: _departmentId }, ROOT);

						case 28:
							_provinces = _context32.sent;
							_context32.next = 31;
							return dispatch("master-data/affiliation-in-process/setProvinces", { addressPropertyType: _addressPropertyType, provinces: _provinces }, ROOT);

						case 31:
							commit("setProvince", {
								addressPropertyType: _addressPropertyType,
								province: _provinces.find(function (p) {
									return p.IdProvince === _provinceId;
								}) || {
									IdProvince: _provinceId
								}
							});

							if (!administrativeAddress.district.IdDistrict) {
								_context32.next = 39;
								break;
							}

							_context32.next = 35;
							return dispatch("master-data/getDistrict", { departmentId: _departmentId, provinceId: _provinceId }, ROOT);

						case 35:
							_districts = _context32.sent;
							_context32.next = 38;
							return dispatch("master-data/affiliation-in-process/setDistricts", { addressPropertyType: _addressPropertyType, districts: _districts }, ROOT);

						case 38:
							commit("setDistrict", {
								addressPropertyType: _addressPropertyType,
								district: _districts.find(function (p) {
									return p.IdDistrict === _districtId;
								}) || {
									IdDistrict: _districtId
								}
							});

						case 39:
						case "end":
							return _context32.stop();
					}
				}
			}, _callee32, this);
		}));

		function loadUbigeoData(_x58) {
			return _ref84.apply(this, arguments);
		}

		return loadUbigeoData;
	}(),
	downloadAffiliationToPrint: function downloadAffiliationToPrint(_ref85) {
		var state = _ref85.state,
		    dispatch = _ref85.dispatch;

		switch (Number(state.productType)) {
			case 1:
				return dispatch("downloadAffiliationPresentialToPrint");
			case 2:
				return dispatch("downloadAffiliationVirtualToPrint");
			default:
				return _Promise.resolve();
		}
	},
	excelFormartWS: function () {
		var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(_ref86) {
			var state = _ref86.state,
			    rootState = _ref86.rootState;

			var isVirtual, _ref88, ruc, businessName, commercialBusiness, administrativeAddress, commercialAddress, legalRepresentativeData, paymentData, quotation, installationSchedule, authorizePersonalDataTreatment, developer, urlPago, appName, appPlatform, bankName, accountNumber, accountType, app, user, MCCI, Moneda, commercialTariffResult, scheduleWeek, businessSchedule, isSoles, membershipType;

			return _regeneratorRuntime.wrap(function _callee33$(_context33) {
				while (1) {
					switch (_context33.prev = _context33.next) {
						case 0:
							isVirtual = getters.isVirtual;
							_ref88 = state.rucValidation || {}, ruc = _ref88.ruc, businessName = _ref88.businessName;
							commercialBusiness = state.businessData.commerceData.commercialBusiness || {};
							administrativeAddress = state.businessData.administrativeAddress || {};
							commercialAddress = state.businessData.commercialAddress || {};
							legalRepresentativeData = state.legalRepresentativeData || {};
							paymentData = state.paymentData || {};
							quotation = state.quotation || {};
							installationSchedule = state.installationSchedule || {};
							authorizePersonalDataTreatment = state.afilliationSummary.authorizePersonalDataTreatment;
							developer = void 0, urlPago = void 0, appName = void 0, appPlatform = void 0, bankName = void 0, accountNumber = void 0, accountType = void 0, app = void 0, user = void 0;

							if (!(isVirtual !== true)) {
								_context33.next = 30;
								break;
							}

							app = state.virtual.app || {};
							user = state.virtual.user || {};
							_context33.t0 = state.productChoice;
							_context33.next = _context33.t0 === "Pago Web" ? 17 : _context33.t0 === "Pago App" ? 20 : 25;
							break;

						case 17:
							developer = state.virtual.webSite.developer;
							urlPago = state.virtual.webSite.url;
							return _context33.abrupt("break", 27);

						case 20:
							urlPago = app.link;
							developer = state.virtual.app.developer;
							appName = app.name;
							appPlatform = app.platform;
							return _context33.abrupt("break", 27);

						case 25:
							developer = {};
							return _context33.abrupt("break", 27);

						case 27:
							if (Moneda === currencyTypeEnum.SOLES) {
								bankName = paymentData.bankNameSoles.Name;
								accountNumber = paymentData.accountNumberSoles;
								accountType = paymentData.accountTypeSoles.Description;
							} else {
								bankName = paymentData.bankNameDolares.Name;
								accountNumber = paymentData.accountNumberDolares;
								accountType = paymentData.accountTypeDolares.Description;
							}
							_context33.next = 31;
							break;

						case 30:
							if (Moneda === currencyTypeEnum.SOLES) {
								bankName = (paymentData.bankNameSoles || { Name: "" }).Name;
							} else {
								bankName = (paymentData.bankNameDolares || { Name: "" }).Name;
							}
							// console.log('bankName', bankName)

						case 31:
							// const MCCI = Number(commercialBusiness.Code)
							MCCI = (commercialBusiness.Code + " - " + commercialBusiness.Description).trim();
							Moneda = paymentData.currencyType;
							commercialTariffResult = state.commercialTariffResults.find(function (ctf) {
								return ctf.currency === Moneda;
							}) || {};
							scheduleWeek = "";
							businessSchedule = state.businessSchedule || {};
							isSoles = Moneda == 1;
							membershipType = state.membershipType.type;


							businessSchedule.schedule.forEach(function (element) {
								if (scheduleWeek == "") {
									element == 0 ? scheduleWeek = "Lun" : element == 1 ? scheduleWeek = "Mar" : element == 2 ? scheduleWeek = "Mie" : element == 3 ? scheduleWeek = "Jue" : element == 4 ? scheduleWeek = "Vie" : element == 5 ? scheduleWeek = "Sab" : scheduleWeek = "Dom";
								} else {
									if (element != -1) {
										element == 1 ? scheduleWeek = scheduleWeek + ", Mar" : element == 2 ? scheduleWeek = scheduleWeek + ", Mie" : element == 3 ? scheduleWeek = scheduleWeek + ", Jue" : element == 4 ? scheduleWeek = scheduleWeek + ", Vie" : element == 5 ? scheduleWeek = scheduleWeek + ", Sab" : scheduleWeek = scheduleWeek + ", Dom";
									}
								}
							});
							scheduleWeek = scheduleWeek + " (" + businessSchedule.startTime + " - " + businessSchedule.endTime + ")";

							// console.log('quotation---->', quotation)
							_context33.next = 42;
							return {
								commerceCode: state.affiliateResults.length ? state.affiliateResults[0].code : "",
								executive: (rootState.user.firstName + " " + rootState.user.lastName).trim(),
								commercialName: state.businessData.commerceData.tradeName,
								businessName: businessName,
								ruc: ruc,
								MCCI: MCCI,
								MCCN: isVirtual !== true ? commercialTariffResult.mccn : MCCI,
								membershipType: membershipType,
								commercialAddress: {
									department: (commercialAddress.department || { Name: "" }).Name,
									province: (commercialAddress.province || { Name: "" }).Name,
									district: (commercialAddress.district || { Name: "" }).Name,
									cellphoneOne: commercialAddress.cellPhone,
									cellphoneTwo: commercialAddress.landline,
									roadType: (commercialAddress.typeOfRoad || { Name: "" }).Name,
									roadName: commercialAddress.nameOfRoad,
									number: commercialAddress.numberOfRoad,
									interiorType: (commercialAddress.interiorType || { Name: "" }).Name,
									interiorName: commercialAddress.interior,
									plusCode: commercialAddress.plusCode,
									km: commercialAddress.km,
									block: commercialAddress.block,
									lot: commercialAddress.allotment,
									reference: commercialAddress.reference,
									typeUrbanHabilitation: commercialAddress.typeUrbanHabilitation,
									urbanHabilitation: commercialAddress.urbanHabilitation,
									schedule: scheduleWeek
								},
								rent: {
									soles: state.quotation.rentalPrice,
									dolares: state.quotation.rentalPriceDolares
								},
								sameACommercialAddress: state.businessData.adminCommerEquals,
								administrativeAddress: administrativeAddress.typeOfRoad.Description + " " + administrativeAddress.nameOfRoad + " " + administrativeAddress.numberOfRoad,
								department: "" + administrativeAddress.department.Name,
								province: "" + administrativeAddress.province.Name,
								district: "" + administrativeAddress.district.Name,

								legalRepresentative: {
									paternalLastname: legalRepresentativeData.paternalName,
									maternalLastname: legalRepresentativeData.maternalName,
									names: legalRepresentativeData.firstName,
									documentType: legalRepresentativeData.documentType.Description,
									documentNumber: legalRepresentativeData.documentNumber,
									phone: legalRepresentativeData.secondPhone,
									cellphone: legalRepresentativeData.cellPhone,
									email: legalRepresentativeData.email,
									birthdate: legalRepresentativeData.birthdate
								},
								connectionType: (state.posSelected || { TipoConexion: "" }).TipoConexion,
								multicommerce: "",
								// equipmentNumber: Number(quotation.posNumber),
								equipmentNumber: state.afilliationSummary && state.afilliationSummary.equipment ? Number(state.afilliationSummary.equipment.value) : 0,
								relatedTariff: {
									creditCommissionNacional: commercialTariffResult.creditCommission + " %",
									creditCommissionInternational: commercialTariffResult.creditCommission + " %",
									creditDebitNacional: commercialTariffResult.debitCommission + " %",
									creditDebitInternational: commercialTariffResult.debitCommission + " %",
									equipmentInstalation: state.afilliationSummary.installationCost,
									quota: state.afilliationSummary.dues ? state.afilliationSummary.dues.value : "01",
									monthlyRental: state.afilliationSummary.rentalSoles,
									monthlyAccountStatement: quotation.stateShippingCost
								},
								osvType: (state.osvType.osvType || { Code: "" }).Code,
								administratorPMM: {
									fullname: user.fullname,
									email: user.email,
									phone: user.phone
								},
								paymentData: isVirtual !== false ? {
									currencyType: Moneda,
									bankNameSoles: (paymentData.bankNameSoles || { Name: "" }).Name,
									accountTypeSoles: (paymentData.accountTypeSoles || { Description: "" }).Description,
									accountNumberSoles: paymentData.accountNumberSoles,
									bankNameDolares: (paymentData.bankNameDolares || { Name: "" }).Name,
									accountTypeDolares: (paymentData.accountTypeDolares || { Description: "" }).Description,
									accountNumberDolares: paymentData.accountNumberDolares,
									bankName: Moneda === currencyTypeEnum.SOLES ? (paymentData.bankNameSoles || { Name: "" }).Name : (paymentData.bankNameDolares || { Name: "" }).Name
								} : {
									currencyType: mapToVirtualValue("moneda", Moneda),
									bankName: bankName,
									accountType: accountType,
									accountNumberSoles: accountNumber
								},
								transactionData: {
									subProduct: state.productChoice,
									currency: mapToVirtualValue("moneda", Moneda),
									creditCommissionNacional: commercialTariffResult.creditCommission + " %",
									creditCommissionInternational: commercialTariffResult.creditCommission + " %",
									creditDebitNacional: commercialTariffResult.debitCommission + " %",
									creditDebitInternational: commercialTariffResult.debitCommission + " %",
									integration: String(state.posSelected[isSoles ? "priceSoles" : "priceDolares"]).replace("null", "").replace("undefined", "") || "",
									// plataformUse: posSelected.usePlatformWebCost,
									plataformUse: state.afilliationSummary ? "$ " + state.afilliationSummary.usePlatformWebCost : null,
									monthlyMaintenance: state.afilliationSummary ? isSoles ? state.afilliationSummary.maintenancePriceCost ? "S/ " + state.afilliationSummary.maintenancePriceCost : null : state.afilliationSummary.maintenancePriceCostDolar ? "$ " + state.afilliationSummary.maintenancePriceCostDolar : null : null,
									// monthlyMaintenance: state.quotation[isSoles ? 'maintenancePriceCost' : 'maintenancePriceCostDolar'],
									annualRenewal: state.productChoice === "Pago Web" ? "" : state.productChoice === "Pago Link" ? "" : state.afilliationSummary ? isSoles ? state.afilliationSummary.renovation : state.afilliationSummary.renovationDolares : null,
									// annualRenewal: (tarifas && (isSoles ? tarifas.renovation : tarifas.renovationDolares)) || '',
									monthlyAccountState: state.posSelected && state.posSelected.tarifas ? String(state.posSelected.tarifas[isSoles ? "shippingFullSoles" : "shippingFull"]).replace("null", "").replace("undefined", "") : null
								},
								virtualShop: {
									pageURL: urlPago,
									appName: appName,
									OS: appPlatform
								},
								developer: {
									delevelopType: developer.developmentType,
									fullname: developer.fullname,
									company: developer.company,
									phone: developer.phone,
									email: developer.email
								},
								installationContact: {
									paternalLastname: installationSchedule.paternalLastname,
									maternalLastname: installationSchedule.maternalLastname,
									names: installationSchedule.name,
									cellphone: installationSchedule.phone,
									email: installationSchedule.email,
									phone: installationSchedule.phone
								},
								authorizePersonalDataTreatment: authorizePersonalDataTreatment,
								// reference: commercialAddress.reference,
								reference: administrativeAddress.reference
							};

						case 42:
							return _context33.abrupt("return", _context33.sent);

						case 43:
						case "end":
							return _context33.stop();
					}
				}
			}, _callee33, this);
		}));

		function excelFormartWS(_x59) {
			return _ref87.apply(this, arguments);
		}

		return excelFormartWS;
	}(),
	downloadAffiliationPresentialToPrint: function downloadAffiliationPresentialToPrint(_ref89) {
		var state = _ref89.state,
		    rootState = _ref89.rootState;

		var _ref90 = state.rucValidation || {},
		    ruc = _ref90.ruc,
		    businessName = _ref90.businessName;

		var commercialBusiness = state.businessData.commerceData.commercialBusiness || {};
		var administrativeAddress = state.businessData.administrativeAddress || {};
		var commercialAddress = state.businessData.commercialAddress || {};
		var legalRepresentativeData = state.legalRepresentativeData || {};
		var paymentData = state.paymentData || {};
		var quotation = state.quotation || {};
		var installationSchedule = state.installationSchedule || {};

		// const MCCI = Number(commercialBusiness.Code)
		var MCCI = (commercialBusiness.Code + " - " + commercialBusiness.Description).trim();
		var Moneda = paymentData.currencyType;
		var commercialTariffResult = state.commercialTariffResults.find(function (ctf) {
			return ctf.currency === Moneda;
		}) || {};
		var scheduleWeek = "";
		var businessSchedule = state.businessSchedule || {};
		var membershipType = state.membershipType.type;
		var authorizePersonalDataTreatment = state.afilliationSummary.authorizePersonalDataTreatment;

		businessSchedule.schedule.forEach(function (element) {
			if (scheduleWeek == "") {
				element == 0 ? scheduleWeek = "Lun" : element == 1 ? scheduleWeek = "Mar" : element == 2 ? scheduleWeek = "Mie" : element == 3 ? scheduleWeek = "Jue" : element == 4 ? scheduleWeek = "Vie" : element == 5 ? scheduleWeek = "Sab" : scheduleWeek = "Dom";
			} else {
				if (element != -1) {
					element == 1 ? scheduleWeek = scheduleWeek + ", Mar" : element == 2 ? scheduleWeek = scheduleWeek + ", Mie" : element == 3 ? scheduleWeek = scheduleWeek + ", Jue" : element == 4 ? scheduleWeek = scheduleWeek + ", Vie" : element == 5 ? scheduleWeek = scheduleWeek + ", Sab" : scheduleWeek = scheduleWeek + ", Dom";
				}
			}
		});
		scheduleWeek = scheduleWeek + " (" + businessSchedule.startTime + " - " + businessSchedule.endTime + ")";

		return new AffiliationApi(this.$axios).downloadPosAfiliationRequest({
			commerceCode: state.affiliateResults.length ? state.affiliateResults[0].code : "",
			executive: (rootState.user.firstName + " " + rootState.user.lastName).trim(),
			commercialName: state.businessData.commerceData.tradeName,
			businessName: businessName,
			ruc: ruc,
			MCCI: MCCI,
			MCCN: commercialTariffResult.mccn,
			membershipType: membershipType,
			commercialAddress: {
				department: (commercialAddress.department || { Name: "" }).Name,
				province: (commercialAddress.province || { Name: "" }).Name,
				district: (commercialAddress.district || { Name: "" }).Name,
				cellphoneOne: commercialAddress.cellPhone,
				cellphoneTwo: commercialAddress.landline,
				roadType: (commercialAddress.typeOfRoad || { Name: "" }).Name,
				roadName: commercialAddress.nameOfRoad,
				number: commercialAddress.numberOfRoad,
				interiorType: (commercialAddress.interiorType || { Name: "" }).Name,
				interiorName: commercialAddress.interior,
				plusCode: commercialAddress.plusCode,
				km: commercialAddress.km,
				block: commercialAddress.block,
				lot: commercialAddress.allotment,
				reference: commercialAddress.reference,
				typeUrbanHabilitation: commercialAddress.typeUrbanHabilitation,
				urbanHabilitation: commercialAddress.urbanHabilitation,
				schedule: scheduleWeek
			},
			sameACommercialAddress: state.businessData.adminCommerEquals,
			administrativeAddress: {
				department: (administrativeAddress.department || { Name: "" }).Name,
				province: (administrativeAddress.province || { Name: "" }).Name,
				district: (administrativeAddress.district || { Name: "" }).Name,
				cellphoneOne: administrativeAddress.cellPhone,
				cellphoneTwo: administrativeAddress.landline,
				roadType: (administrativeAddress.typeOfRoad || { Name: "" }).Name,
				roadName: administrativeAddress.nameOfRoad,
				number: administrativeAddress.numberOfRoad,
				interiorType: (administrativeAddress.interiorType || { Name: "" }).Name,
				interiorName: administrativeAddress.interior,
				plusCode: administrativeAddress.plusCode,
				km: administrativeAddress.km,
				block: administrativeAddress.block,
				lot: administrativeAddress.allotment,
				reference: administrativeAddress.reference,
				typeUrbanHabilitation: administrativeAddress.typeUrbanHabilitation,
				urbanHabilitation: administrativeAddress.urbanHabilitation,
				schedule: scheduleWeek
			},
			legalRepresentative: {
				paternalLastname: legalRepresentativeData.paternalName,
				maternalLastname: legalRepresentativeData.maternalName,
				names: legalRepresentativeData.firstName,
				documentType: legalRepresentativeData.documentType.Description,
				documentNumber: legalRepresentativeData.documentNumber,
				phone: legalRepresentativeData.secondPhone,
				cellphone: legalRepresentativeData.cellPhone,
				email: legalRepresentativeData.email,
				birthdate: legalRepresentativeData.birthdate
			},
			installationContact: {
				paternalLastname: installationSchedule.paternalLastname,
				maternalLastname: installationSchedule.maternalLastname,
				names: installationSchedule.name,
				cellphone: installationSchedule.phone,
				email: installationSchedule.email,
				phone: installationSchedule.phone
			},
			connectionType: (state.posSelected || { TipoConexion: "" }).TipoConexion,
			multicommerce: "",
			equipmentNumber: state.afilliationSummary && state.afilliationSummary.equipment ? Number(state.afilliationSummary.equipment.value) : 0,
			relatedTariff: {
				creditCommissionNacional: commercialTariffResult.creditCommission + " %",
				creditCommissionInternational: commercialTariffResult.creditCommission + " %",
				creditDebitNacional: commercialTariffResult.debitCommission + " %",
				creditDebitInternational: commercialTariffResult.debitCommission + " %",
				equipmentInstalation: state.afilliationSummary.installationCost,
				quota: state.afilliationSummary.dues ? state.afilliationSummary.dues.value : "01",
				monthlyRental: state.afilliationSummary.rentalSoles,
				monthlyAccountStatement: quotation.stateShippingCost
			},
			osvType: (state.osvType.osvType || { Code: "" }).Code,
			paymentData: {
				currencyType: Moneda,
				bankNameSoles: (paymentData.bankNameSoles || { Name: "" }).Name,
				accountTypeSoles: (paymentData.accountTypeSoles || { Description: "" }).Description,
				accountNumberSoles: paymentData.accountNumberSoles,
				bankNameDolares: (paymentData.bankNameDolares || { Name: "" }).Name,
				accountTypeDolares: (paymentData.accountTypeDolares || { Description: "" }).Description,
				accountNumberDolares: paymentData.accountNumberDolares
			},
			authorizePersonalDataTreatment: authorizePersonalDataTreatment
		});
	},
	downloadAffiliationVirtualToPrint: function downloadAffiliationVirtualToPrint(_ref91) {
		var state = _ref91.state,
		    rootState = _ref91.rootState;

		var authorizePersonalDataTreatment = state.afilliationSummary.authorizePersonalDataTreatment;

		var _ref92 = state.rucValidation || {},
		    ruc = _ref92.ruc,
		    businessName = _ref92.businessName;

		var commercialBusiness = state.businessData.commerceData.commercialBusiness || {};

		var administrativeAddress = state.businessData.administrativeAddress || {};

		var legalRepresentativeData = state.legalRepresentativeData || {};

		var paymentData = state.paymentData || {};

		var posSelected = state.posSelected;

		var _ref93 = posSelected || {},
		    tarifas = _ref93.tarifas;

		var app = state.virtual.app || {};
		var user = state.virtual.user || {};

		var MCCI = (commercialBusiness.Code + " - " + commercialBusiness.Description).trim();
		var Moneda = paymentData.currencyType;
		var commercialTariffResult = state.commercialTariffResults.find(function (ctf) {
			return ctf.currency === Moneda;
		}) || {};
		var isSoles = Moneda == 1;

		var developer = void 0,
		    urlPago = void 0,
		    appName = void 0,
		    appPlatform = void 0;
		switch (state.productChoice) {
			case "Pago Web":
				developer = state.virtual.webSite.developer;
				urlPago = state.virtual.webSite.url;
				break;
			case "Pago App":
				urlPago = app.link;
				developer = state.virtual.app.developer;
				appName = app.name;
				appPlatform = app.platform;
				break;
			default:
				developer = {};
				break;
		}

		var bankName = void 0,
		    accountNumber = void 0,
		    accountType = void 0;

		if (Moneda === currencyTypeEnum.SOLES) {
			bankName = paymentData.bankNameSoles.Name;
			accountNumber = paymentData.accountNumberSoles;
			accountType = paymentData.accountTypeSoles.Description;
		} else {
			bankName = paymentData.bankNameDolares.Name;
			accountNumber = paymentData.accountNumberDolares;
			accountType = paymentData.accountTypeDolares.Description;
		}

		return new AffiliationApi(this.$axios).downloadCeAfiliationRequest({
			commerceCode: state.affiliateResults.length ? state.affiliateResults[0].code : "",
			executive: (rootState.user.firstName + " " + rootState.user.lastName).trim(),
			commercialName: state.businessData.commerceData.tradeName,
			businessName: businessName,
			ruc: ruc,
			MCCI: MCCI,
			MCCN: commercialTariffResult.mccn,
			administrativeAddress: administrativeAddress.typeOfRoad.Description + " " + administrativeAddress.nameOfRoad + " " + administrativeAddress.numberOfRoad,
			department: "" + administrativeAddress.department.Name,
			province: "" + administrativeAddress.province.Name,
			district: "" + administrativeAddress.district.Name,
			reference: administrativeAddress.reference,
			legalRepresentative: {
				paternalLastname: legalRepresentativeData.paternalName,
				maternalLastname: legalRepresentativeData.maternalName,
				names: legalRepresentativeData.firstName,
				documentType: legalRepresentativeData.documentType.Description,
				documentNumber: legalRepresentativeData.documentNumber,
				phone: legalRepresentativeData.secondPhone,
				cellphone: legalRepresentativeData.cellPhone,
				email: legalRepresentativeData.email,
				birthdate: legalRepresentativeData.birthdate
			},
			administratorPMM: {
				fullname: user.fullname,
				email: user.email,
				phone: user.phone
			},
			paymentData: {
				currencyType: mapToVirtualValue("moneda", Moneda),
				bankName: bankName,
				accountType: accountType,
				accountNumberSoles: accountNumber
			},
			transactionData: {
				subProduct: state.productChoice,
				currency: mapToVirtualValue("moneda", Moneda),
				creditCommissionNacional: commercialTariffResult.creditCommission + " %",
				creditCommissionInternational: commercialTariffResult.creditCommission + " %",
				creditDebitNacional: commercialTariffResult.debitCommission + " %",
				creditDebitInternational: commercialTariffResult.debitCommission + " %",
				integration: String(state.posSelected[isSoles ? "priceSoles" : "priceDolares"]).replace("null", "").replace("undefined", "") || "",
				plataformUse: state.afilliationSummary && state.afilliationSummary.usePlatformWebCost ? "$ " + state.afilliationSummary.usePlatformWebCost : null,
				monthlyMaintenance: state.afilliationSummary ? isSoles ? state.afilliationSummary.maintenancePriceCost ? "S/ " + state.afilliationSummary.maintenancePriceCost : null : state.afilliationSummary.maintenancePriceCostDolar ? "$ " + state.afilliationSummary.maintenancePriceCostDolar : null : null,

				annualRenewal: state.productChoice === "Pago Web" ? "" : state.productChoice === "Pago Link" ? "" : state.afilliationSummary ? isSoles ? state.afilliationSummary.renovation : state.afilliationSummary.renovationDolares : null,

				monthlyAccountState: state.posSelected && state.posSelected.tarifas ? String(state.posSelected.tarifas[isSoles ? "shippingFullSoles" : "shippingFull"]).replace("null", "").replace("undefined", "") : null
			},

			virtualShop: {
				pageURL: urlPago,
				appName: appName,
				OS: appPlatform
			},
			developer: {
				delevelopType: developer.developmentType,
				fullname: developer.fullname,
				company: developer.company,
				phone: developer.phone,
				email: developer.email
			},
			authorizePersonalDataTreatment: authorizePersonalDataTreatment
		});
	},
	consultComision: function () {
		var _ref95 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(_ref94, data) {
			var state = _ref94.state,
			    getters = _ref94.getters,
			    commit = _ref94.commit,
			    rootState = _ref94.rootState;
			var username, result, comisionesMarca, comisionCreditoOtraPlataforma, comisionDebitoOtraPlataforma, key;
			return _regeneratorRuntime.wrap(function _callee34$(_context34) {
				while (1) {
					switch (_context34.prev = _context34.next) {
						case 0:
							username = rootState.user.username;

							data.audit.usuario = username;
							data.audit.transaccionId = state.idTransactionBimoneda ? state.idTransactionBimoneda : state.idTransaction;
							if (data.obtenerComisionesRequest.cliente.ruc === "") data.obtenerComisionesRequest.cliente.ruc = state.rucValidation.ruc;
							console.log(state.rucValidation);
							_context34.t0 = getters.posName;
							_context34.next = _context34.t0 === presentialPosEnum.POS_FIJO_INTERNET ? 8 : _context34.t0 === presentialPosEnum.POS_FIJO_TELEFONICO ? 8 : _context34.t0 === presentialPosEnum.POS_INALAMBRICO ? 8 : _context34.t0 === presentialPosEnum.CORRESPONSALIA ? 8 : _context34.t0 === virtualPosEnum.PAGO_WEB ? 10 : _context34.t0 === virtualPosEnum.PAGO_LINK ? 12 : _context34.t0 === virtualPosEnum.PAGO_APP ? 14 : 16;
							break;

						case 8:
							data.obtenerComisionesRequest.cliente.oportunidad.subProducto = "BP";
							return _context34.abrupt("break", 16);

						case 10:
							data.obtenerComisionesRequest.cliente.oportunidad.subProducto = subProductEnum.PAGO_WEB;
							return _context34.abrupt("break", 16);

						case 12:
							data.obtenerComisionesRequest.cliente.oportunidad.subProducto = subProductEnum.PAGO_LINK;
							return _context34.abrupt("break", 16);

						case 14:
							data.obtenerComisionesRequest.cliente.oportunidad.subProducto = subProductEnum.PAGO_APP;
							return _context34.abrupt("break", 16);

						case 16:
							data.obtenerComisionesRequest.cliente.oportunidad.producto = getters.isVirtual ? "CE" : "BS";
							_context34.next = 19;
							return new AffiliationApi(this.$axios).getComision(data);

						case 19:
							result = _context34.sent;

							// console.log(result);
							//verify data after to send
							comisionesMarca = result.comisionesMarca, comisionCreditoOtraPlataforma = result.comisionCreditoOtraPlataforma, comisionDebitoOtraPlataforma = result.comisionDebitoOtraPlataforma;


							if (comisionCreditoOtraPlataforma == undefined || comisionCreditoOtraPlataforma == "") result.comisionCreditoOtraPlataforma = "0.00";
							if (comisionDebitoOtraPlataforma == undefined || comisionDebitoOtraPlataforma == "") result.comisionDebitoOtraPlataforma = "0.00";

							key = _Object$values(comisionesMarca);


							key.forEach(function (dta) {
								if (dta.indicadorMarca == undefined || dta.indicadorMarca == "") dta.indicadorMarca = false;
								if (dta.fechaInicioCampana == undefined || dta.fechaInicioCampana == "") delete dta.fechaInicioCampana;
								if (dta.fechaFinCampana == undefined || dta.fechaFinCampana == "") delete dta.fechaFinCampana;
							});
							comisionesMarca = key;

							result.comisionesMarca = comisionesMarca;

							commit("setComission", result);
							// console.log(result);
							return _context34.abrupt("return", result);

						case 29:
						case "end":
							return _context34.stop();
					}
				}
			}, _callee34, this);
		}));

		function consultComision(_x60, _x61) {
			return _ref95.apply(this, arguments);
		}

		return consultComision;
	}(),
	newConsultComision: function () {
		var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref96, data) {
			var state = _ref96.state,
			    getters = _ref96.getters,
			    commit = _ref96.commit,
			    rootState = _ref96.rootState;
			var username, result, comisionesMarca, comisionCreditoOtraPlataforma, comisionDebitoOtraPlataforma, key;
			return _regeneratorRuntime.wrap(function _callee35$(_context35) {
				while (1) {
					switch (_context35.prev = _context35.next) {
						case 0:
							username = rootState.user.username;

							data.audit.usuario = username;
							data.audit.transaccionId = state.idTransaction || "2001";
							if (data.obtenerComisionesRequest.cliente.ruc === "") data.obtenerComisionesRequest.cliente.ruc = state.rucValidation.ruc;
							_context35.next = 6;
							return new AffiliationApi(this.$axios).getComision(data);

						case 6:
							result = _context35.sent;

							// console.log(result);
							//verify data after to send
							comisionesMarca = result.comisionesMarca, comisionCreditoOtraPlataforma = result.comisionCreditoOtraPlataforma, comisionDebitoOtraPlataforma = result.comisionDebitoOtraPlataforma;


							if (comisionCreditoOtraPlataforma == undefined || comisionCreditoOtraPlataforma == "") result.comisionCreditoOtraPlataforma = "0.00";
							if (comisionDebitoOtraPlataforma == undefined || comisionDebitoOtraPlataforma == "") result.comisionDebitoOtraPlataforma = "0.00";

							key = _Object$values(comisionesMarca);


							key.forEach(function (dta) {
								if (dta.indicadorMarca == undefined || dta.indicadorMarca == "") dta.indicadorMarca = false;
								if (dta.fechaInicioCampana == undefined || dta.fechaInicioCampana == "") delete dta.fechaInicioCampana;
								if (dta.fechaFinCampana == undefined || dta.fechaFinCampana == "") delete dta.fechaFinCampana;
							});
							comisionesMarca = key;

							result.comisionesMarca = comisionesMarca;

							commit("setComission", result);
							// console.log(result);
							return _context35.abrupt("return", result);

						case 16:
						case "end":
							return _context35.stop();
					}
				}
			}, _callee35, this);
		}));

		function newConsultComision(_x62, _x63) {
			return _ref97.apply(this, arguments);
		}

		return newConsultComision;
	}(),
	consultMcci: function () {
		var _ref99 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref98, mcci) {
			var commit = _ref98.commit,
			    getters = _ref98.getters;
			var subProductCode, result;
			return _regeneratorRuntime.wrap(function _callee36$(_context36) {
				while (1) {
					switch (_context36.prev = _context36.next) {
						case 0:
							console.log("----POS NAME---", getters.posName);
							subProductCode = void 0;
							_context36.t0 = getters.posName;
							_context36.next = _context36.t0 === presentialPosEnum.POS_FIJO_INTERNET ? 5 : _context36.t0 === presentialPosEnum.POS_FIJO_TELEFONICO ? 5 : _context36.t0 === presentialPosEnum.POS_INALAMBRICO ? 5 : _context36.t0 === presentialPosEnum.CORRESPONSALIA ? 5 : _context36.t0 === virtualPosEnum.PAGO_WEB ? 7 : _context36.t0 === virtualPosEnum.PAGO_LINK ? 9 : _context36.t0 === virtualPosEnum.PAGO_APP ? 11 : 13;
							break;

						case 5:
							subProductCode = "BP";
							return _context36.abrupt("break", 13);

						case 7:
							subProductCode = subProductEnum.PAGO_WEB;
							return _context36.abrupt("break", 13);

						case 9:
							subProductCode = subProductEnum.PAGO_LINK;
							return _context36.abrupt("break", 13);

						case 11:
							subProductCode = subProductEnum.PAGO_APP;
							return _context36.abrupt("break", 13);

						case 13:
							_context36.next = 15;
							return new AffiliationApi(this.$axios).consultMcci({
								productCode: getters.isVirtual ? "CE" : "BS",
								subProductCode: subProductCode,
								mcci: mcci
							});

						case 15:
							result = _context36.sent;


							commit("setConsultMcciResult", result);
							commit("setMcciForGrifo", mcci);

							return _context36.abrupt("return", result);

						case 19:
						case "end":
							return _context36.stop();
					}
				}
			}, _callee36, this);
		}));

		function consultMcci(_x64, _x65) {
			return _ref99.apply(this, arguments);
		}

		return consultMcci;
	}(),
	consultChannel: function () {
		var _ref100 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
			return _regeneratorRuntime.wrap(function _callee37$(_context37) {
				while (1) {
					switch (_context37.prev = _context37.next) {
						case 0:
							_context37.t0 = responseToState;
							_context37.next = 3;
							return new AffiliationApi(this.$axios).consultChannel();

						case 3:
							_context37.t1 = _context37.sent;
							return _context37.abrupt("return", (0, _context37.t0)(_context37.t1, "idChannel", "description"));

						case 5:
						case "end":
							return _context37.stop();
					}
				}
			}, _callee37, this);
		}));

		function consultChannel() {
			return _ref100.apply(this, arguments);
		}

		return consultChannel;
	}(),
	consultSubChannel: function () {
		var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(_ref101, channelId) {
			return _regeneratorRuntime.wrap(function _callee38$(_context38) {
				while (1) {
					switch (_context38.prev = _context38.next) {
						case 0:
							_objectDestructuringEmpty(_ref101);

							_context38.t0 = responseToState;
							_context38.next = 4;
							return new AffiliationApi(this.$axios).consultSubChannel(channelId);

						case 4:
							_context38.t1 = _context38.sent;
							return _context38.abrupt("return", (0, _context38.t0)(_context38.t1, "idSubChannel", "description"));

						case 6:
						case "end":
							return _context38.stop();
					}
				}
			}, _callee38, this);
		}));

		function consultSubChannel(_x66, _x67) {
			return _ref102.apply(this, arguments);
		}

		return consultSubChannel;
	}(),
	consultGroupChannel: function () {
		var _ref104 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(_ref103, subChannelId) {
			return _regeneratorRuntime.wrap(function _callee39$(_context39) {
				while (1) {
					switch (_context39.prev = _context39.next) {
						case 0:
							_objectDestructuringEmpty(_ref103);

							_context39.t0 = responseToState;
							_context39.next = 4;
							return new AffiliationApi(this.$axios).consultGroupChannel(subChannelId);

						case 4:
							_context39.t1 = _context39.sent;
							return _context39.abrupt("return", (0, _context39.t0)(_context39.t1, "idGroupChannel", "description"));

						case 6:
						case "end":
							return _context39.stop();
					}
				}
			}, _callee39, this);
		}));

		function consultGroupChannel(_x68, _x69) {
			return _ref104.apply(this, arguments);
		}

		return consultGroupChannel;
	}(),
	checkGenerateCommerceCodeResult: function () {
		var _ref106 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(_ref105, data) {
			var state = _ref105.state;

			var membershipRequirements, idTransaction, affiliationApi, codigoComercio, id, _data$message, afiliarComercioResponse, resultado, estadoOper, infoMapOper, info;

			return _regeneratorRuntime.wrap(function _callee40$(_context40) {
				while (1) {
					switch (_context40.prev = _context40.next) {
						case 0:
							membershipRequirements = state.membershipRequirements, idTransaction = state.idTransaction;
							affiliationApi = new AffiliationApi(this.$axios);

							if (!(data && data.status)) {
								_context40.next = 38;
								break;
							}

							if (!(data.status === 200)) {
								_context40.next = 18;
								break;
							}

							codigoComercio = data.codigoComercio, id = data.id;

							if (!(codigoComercio === "0")) {
								_context40.next = 16;
								break;
							}

							if (!(state.multiAdress.length === 0)) {
								_context40.next = 16;
								break;
							}

							_context40.prev = 7;
							_context40.next = 10;
							return affiliationApi.addCommerceCodeFile(idTransaction, String(id));

						case 10:
							_context40.next = 15;
							break;

						case 12:
							_context40.prev = 12;
							_context40.t0 = _context40["catch"](7);
							throw new WarningError("Ocurrió un error en la subida de archivos. Intente nuevamente por favor.");

						case 15:
							throw new OnHoldError({
								message: "Afiliacion en espera",
								platformRecordId: id
							});

						case 16:
							_context40.next = 36;
							break;

						case 18:
							if (!(data.status === 400)) {
								_context40.next = 22;
								break;
							}

							throw new WarningError("Error en SAP: " + data.message + ". Intente nuevamente por favor.");

						case 22:
							if (!(data.status === 409)) {
								_context40.next = 35;
								break;
							}

							_data$message = data.message, afiliarComercioResponse = _data$message.afiliarComercioResponse, resultado = _data$message.resultado;
							estadoOper = resultado.estadoOper;
							infoMapOper = afiliarComercioResponse.infoMapOper;
							info = infoMapOper.info;

							if (!(estadoOper !== "0")) {
								_context40.next = 33;
								break;
							}

							if (!(info[0].codigo === "2602")) {
								_context40.next = 32;
								break;
							}

							throw new WarningError("Error en SAP: " + info[0].mensaje + ". Intente nuevamente por favor.");

						case 32:
							throw new WarningError("Error en SAP: " + info[0].mensaje + ". Intente nuevamente por favor.");

						case 33:
							_context40.next = 36;
							break;

						case 35:
							throw new WarningError("Error. Intente nuevamente por favor");

						case 36:
							_context40.next = 39;
							break;

						case 38:
							throw new WarningError("Ocurrió un error. Intente nuevamente por favor.");

						case 39:
						case "end":
							return _context40.stop();
					}
				}
			}, _callee40, this, [[7, 12]]);
		}));

		function checkGenerateCommerceCodeResult(_x70, _x71) {
			return _ref106.apply(this, arguments);
		}

		return checkGenerateCommerceCodeResult;
	}(),
	consultarCliente: function () {
		var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(_ref107, data) {
			var state = _ref107.state,
			    getters = _ref107.getters,
			    commit = _ref107.commit,
			    rootState = _ref107.rootState;

			var _rootState$user2, username, channelName, subChannelName, firstName, lastName, result;

			return _regeneratorRuntime.wrap(function _callee41$(_context41) {
				while (1) {
					switch (_context41.prev = _context41.next) {
						case 0:
							_rootState$user2 = rootState.user, username = _rootState$user2.username, channelName = _rootState$user2.channelName, subChannelName = _rootState$user2.subChannelName, firstName = _rootState$user2.firstName, lastName = _rootState$user2.lastName;
							// console.log("data ", data);

							_context41.next = 3;
							return new AffiliationApi(this.$axios).consultCliente({
								ruc: data.ruc,
								username: username,
								channelName: channelName,
								subChannelName: subChannelName,
								user: "1"
							});

						case 3:
							result = _context41.sent;
							return _context41.abrupt("return", result);

						case 5:
						case "end":
							return _context41.stop();
					}
				}
			}, _callee41, this);
		}));

		function consultarCliente(_x72, _x73) {
			return _ref108.apply(this, arguments);
		}

		return consultarCliente;
	}(),
	createLogComission: function () {
		var _ref110 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(_ref109) {
			var state = _ref109.state,
			    getters = _ref109.getters,
			    commit = _ref109.commit,
			    rootState = _ref109.rootState;

			var _rootState$user3, username, channelName, subChannelName, firstName, lastName, result;

			return _regeneratorRuntime.wrap(function _callee42$(_context42) {
				while (1) {
					switch (_context42.prev = _context42.next) {
						case 0:
							_rootState$user3 = rootState.user, username = _rootState$user3.username, channelName = _rootState$user3.channelName, subChannelName = _rootState$user3.subChannelName, firstName = _rootState$user3.firstName, lastName = _rootState$user3.lastName;
							_context42.next = 3;
							return new AffiliationApi(this.$axios).createLogComision({
								user: firstName + " " + lastName,
								channelName: channelName,
								subChannelName: subChannelName
							});

						case 3:
							result = _context42.sent;
							return _context42.abrupt("return", result);

						case 5:
						case "end":
							return _context42.stop();
					}
				}
			}, _callee42, this);
		}));

		function createLogComission(_x74) {
			return _ref110.apply(this, arguments);
		}

		return createLogComission;
	}(),
	sendDataMultiAdress: function () {
		var _ref112 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref111, indice) {
			var state = _ref111.state,
			    commit = _ref111.commit,
			    dispatch = _ref111.dispatch,
			    getters = _ref111.getters,
			    rootState = _ref111.rootState;

			var commercialTariffResults, membershipRequirements, idTransactionBimoneda, affiliationApi, commercialTariffResultSoles, commercialTariffResultDolares, isNotBimoney, isVirtual, isPresential, commerceCodes, requestSoles, requestDolares, mapCommerce, generateCommerceCodeSoles, _mapCommerce4, generateCommerceCodeDolares, _mapCommerce5, _generateCommerceCodeSoles2, _mapCommerce6, _generateCommerceCodeDolares2;

			return _regeneratorRuntime.wrap(function _callee43$(_context43) {
				while (1) {
					switch (_context43.prev = _context43.next) {
						case 0:
							commercialTariffResults = state.commercialTariffResults, membershipRequirements = state.membershipRequirements, idTransactionBimoneda = state.idTransactionBimoneda;
							affiliationApi = new AffiliationApi(this.$axios);
							commercialTariffResultSoles = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.SOLES;
							});
							commercialTariffResultDolares = commercialTariffResults.find(function (c) {
								return c.currency === currencyTypeEnum.DOLARES;
							});
							isNotBimoney = commercialTariffResults.length === 1;
							isVirtual = getters.isVirtual;
							isPresential = getters.isPresential;
							commerceCodes = [];
							requestSoles = {
								state: state,
								commercialTariffResult: commercialTariffResultSoles,
								isNotBimoney: isNotBimoney,
								isVirtual: isVirtual,
								isPresential: isPresential,
								user: rootState.user,
								masterData: rootState['master-data'],
								isMulti: false,
								requestModalityBimoneda: {
									motivoOrden: '',
									subMotivoOrden: ''
								},
								idTransactionBimoneda: null,
								indiceMultiAdrees: indice
							};
							requestDolares = {
								state: state,
								commercialTariffResult: commercialTariffResultDolares,
								isNotBimoney: isNotBimoney,
								isVirtual: isVirtual,
								isPresential: isPresential,
								user: rootState.user,
								masterData: rootState['master-data'],
								isMulti: false,
								requestModalityBimoneda: {
									motivoOrden: '',
									subMotivoOrden: ''
								},
								idTransactionBimoneda: idTransactionBimoneda,
								indiceMultiAdrees: indice
							};

							if (!(state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES)) {
								_context43.next = 34;
								break;
							}

							if (!((isVirtual || isPresential) && commercialTariffResultSoles)) {
								_context43.next = 22;
								break;
							}

							requestSoles.requestModalityBimoneda.motivoOrden = 'RGS', requestSoles.requestModalityBimoneda.subMotivoOrden = 'RGS_MLT';
							requestSoles.isMulti = true;
							mapCommerce = newMapRequestGenerateCommerceCodeMultiAdress(requestSoles);
							_context43.next = 17;
							return affiliationApi.generateCommerceCode(mapCommerce);

						case 17:
							generateCommerceCodeSoles = _context43.sent;
							_context43.next = 20;
							return dispatch('checkGenerateCommerceCodeResult', generateCommerceCodeSoles);

						case 20:
							commerceCodes.push({
								code: generateCommerceCodeSoles.codigoComercio,
								text: 'para Soles',
								resultApi: generateCommerceCodeSoles
							});
							if (state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) commit('setCommerceCodePadre', generateCommerceCodeSoles.codigoComercio);

						case 22:
							if (!((isVirtual || isPresential) && commercialTariffResultDolares)) {
								_context43.next = 32;
								break;
							}

							requestDolares.requestModalityBimoneda.motivoOrden = 'RGS', requestDolares.requestModalityBimoneda.subMotivoOrden = 'RGS_MLT';
							_mapCommerce4 = newMapRequestGenerateCommerceCodeMultiAdress(requestDolares);
							_context43.next = 27;
							return affiliationApi.generateCommerceCode(_mapCommerce4);

						case 27:
							generateCommerceCodeDolares = _context43.sent;
							_context43.next = 30;
							return dispatch('checkGenerateCommerceCodeResult', generateCommerceCodeDolares);

						case 30:
							commit('setCommerceCodePadre', '');
							commerceCodes.push({
								code: generateCommerceCodeDolares.codigoComercio,
								text: 'para Dólares',
								resultApi: generateCommerceCodeDolares
							});

						case 32:
							_context43.next = 52;
							break;

						case 34:
							if (!((isVirtual || isPresential) && commercialTariffResultSoles)) {
								_context43.next = 43;
								break;
							}

							_mapCommerce5 = newMapRequestGenerateCommerceCodeMultiAdress(requestSoles);
							_context43.next = 38;
							return affiliationApi.generateCommerceCode(_mapCommerce5);

						case 38:
							_generateCommerceCodeSoles2 = _context43.sent;
							_context43.next = 41;
							return dispatch('checkGenerateCommerceCodeResult', _generateCommerceCodeSoles2);

						case 41:
							commerceCodes.push({
								code: _generateCommerceCodeSoles2.codigoComercio,
								text: 'para Soles',
								resultApi: _generateCommerceCodeSoles2
							});
							if (state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) commit('setCommerceCodePadre', _generateCommerceCodeSoles2.codigoComercio);

						case 43:
							if (!((isVirtual || isPresential) && commercialTariffResultDolares)) {
								_context43.next = 52;
								break;
							}

							_mapCommerce6 = newMapRequestGenerateCommerceCodeMultiAdress(requestDolares);
							_context43.next = 47;
							return affiliationApi.generateCommerceCode(_mapCommerce6);

						case 47:
							_generateCommerceCodeDolares2 = _context43.sent;
							_context43.next = 50;
							return dispatch('checkGenerateCommerceCodeResult', _generateCommerceCodeDolares2);

						case 50:
							commit('setCommerceCodePadre', '');
							commerceCodes.push({
								code: _generateCommerceCodeDolares2.codigoComercio,
								text: 'para Dólares',
								resultApi: _generateCommerceCodeDolares2
							});

						case 52:
							console.log("Fin send data multi");
							if (isVirtual || isPresential) {
								commit('setCommerceCode', commerceCodes);
								commit('setAffiliateResults', commerceCodes);
							}

							return _context43.abrupt("return", commerceCodes);

						case 55:
						case "end":
							return _context43.stop();
					}
				}
			}, _callee43, this);
		}));

		function sendDataMultiAdress(_x75, _x76) {
			return _ref112.apply(this, arguments);
		}

		return sendDataMultiAdress;
	}()
};

export var mutations = {
	setEquipmentType: function setEquipmentType(state, data) {
		state.tipoEquipo = data;
	},
	setDataTableEmpty: function setDataTableEmpty(state) {
		state.dataTable = [];
	},
	setInfoTableEmpty: function setInfoTableEmpty(state) {
		state.infoTable = {
			countInHold: 0,
			countNotWorked: 0,
			countWorked: 0
		};
	},
	setEsPOSPinpadMpos: function setEsPOSPinpadMpos(state, data) {
		state.esPOSPinpadMpos = data;
	},
	setLogout: function setLogout(state, data) {
		state.logoutInAffiliation = data;
	},
	setData: function setData(state, _ref113) {
		var stateName = _ref113.stateName,
		    data = _ref113.data;

		state[stateName] = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? _Object$assign({}, state[stateName], data) : data;
	},
	setCorresponsaliaAgent: function setCorresponsaliaAgent(state, agent) {
		state.corresponsaliaData.header.agent = agent;
	},
	setCorresponsaliaAffiliationType: function setCorresponsaliaAffiliationType(state, affiliationType) {
		state.corresponsaliaData.header.affiliationType = affiliationType;
	},
	setCorresponsaliaBankAccount: function setCorresponsaliaBankAccount(state, bankAccount) {
		state.corresponsaliaData.header.bankAccount = bankAccount;
	},
	setCorresponsaliaAgentData: function setCorresponsaliaAgentData(state, agentData) {
		state.corresponsaliaData.agentData = agentData;
	},
	setSegmento: function setSegmento(state, data) {
		state.segmento = data;
	},
	setTypeModalityTitle: function setTypeModalityTitle(state, data) {
		state.typeModalityTitle = data;
	},
	setCurrencyTypeBimoneda: function setCurrencyTypeBimoneda(state, data) {
		state.currencyTypeBimoneda = data;
	},
	setCommerceCodePadre: function setCommerceCodePadre(state, data) {
		state.commerceCodePadre = data;
	},
	setMcciForGrifo: function setMcciForGrifo(state, data) {
		state.mcciForGrifo = data;
	},
	setIdTransactionBimoneda: function setIdTransactionBimoneda(state, data) {
		state.idTransactionBimoneda = data;
	},
	emptyData: function emptyData(state) {
		state.idAffiliation = 0;
		state.idAffiliationProcess = 0;
		state.step = 1;
		state.showSteppeds = false;
		state.productType = null;
		state.productChoice = null;
		state.processInitDate = "";
		state.posSelected = {
			pos: "",
			id: null,
			priceSoles: "",
			priceDolares: "",
			TipoConexion: "",
			rental: {
				uniqueMoney: {
					soles: 0,
					dolares: 0
				},
				biMoney: {
					soles: 0,
					dolares: 0
				}
			},
			tarifas: {}
		};
		state.rucValidation = {
			ruc: null,
			businessName: "",
			consultDate: null
		};
		state.membershipType = {
			type: "IND",
			startDate: null,
			endDate: null
		};
		state.legalRepresentativeData = {
			id: 0,
			firstName: "",
			maternalName: "",
			paternalName: "",
			documentType: "",
			documentNumber: "",
			cellPhone: "",
			secondPhone: "",
			email: "",
			birthdate: "",
			consultDate: null
		};
		state.businessData = {
			adminCommerEquals: "",
			refData: [],
			commerceData: {
				id: null,
				tradeName: "",
				email: "",
				commercialBusiness: null,
				nationalMcc: "",
				applyToPartnerPlan: ""
			},
			commercialAddress: {
				id: null,
				department: "",
				province: "",
				district: "",
				typeOfRoad: "",
				nameOfRoad: "",
				numberOfRoad: "",
				plusCode: "",
				km: "",
				block: "",
				allotment: "",
				interiorType: "",
				interior: "",
				reference: "",
				cellPhone: "",
				prefix: "",
				landline: "",
				typeUrbanHabilitation: {},
				urbanHabilitation: ""
			},
			administrativeAddress: {
				id: null,
				department: "",
				province: "",
				district: "",
				typeOfRoad: "",
				nameOfRoad: "",
				numberOfRoad: "",
				plusCode: "",
				km: "",
				block: "",
				allotment: "",
				interiorType: "",
				interior: "",
				reference: "",
				cellPhone: "",
				prefix: "",
				landline: "",
				typeUrbanHabilitation: {},
				urbanHabilitation: ""
			}
		};
		state.businessSchedule = {
			id: null,
			idSchedule: null,
			schedule: [],
			initDay: "",
			endDay: "",
			startTime: null,
			endTime: null
		};
		state.installationSchedule = {
			id: null,
			serviceHours: [],
			name: "",
			phone: "",
			paternalLastname: null,
			maternalLastname: null,
			email: null,
			documentType: null,
			documentNumber: null
		};
		state.paymentData = {
			currencyType: "",
			idSoles: null,
			bankNameSoles: "",
			accountTypeSoles: "",
			accountNumberSoles: "",
			alternativeAccountNumberSoles: "",
			idDolares: null,
			bankNameDolares: "",
			accountTypeDolares: "",
			accountNumberDolares: "",
			alternativeAccountNumberDolares: ""
		};
		state.membershipRequirements = {
			url: [],
			sapFiles: []
		};
		state.osvType = {
			osvType: null,
			commercialCode: null
		};
		state.quotation = {
			posName: "",
			posNumber: "1",
			taxQuota: "01",
			installationCost: null,
			installationCostDolar: null,
			rentalPrice: 0.0,
			rentalPriceDolares: 0.0,
			maintenancePriceCost: 0,
			maintenancePriceCostDolar: 0,
			stateShippingCost: 5.0,
			stateShippingCostDolar: 1.5,
			creditCardCommission: "4.5%",
			debitCardCommission: "3.8%"
		};
		state.afilliationSummary = {
			id: null,
			equiptment: "",
			dues: "",
			authorizePersonalDataTreatment: null,
			posName: null,
			posNumber: null,
			installationCost: null,
			installationCostDolar: null,
			rentalSoles: null,
			rentalDolares: null,
			maintenancePriceCost: null,
			maintenancePriceCostDolar: null,
			usePlatformWebCost: null
		};
		state.ubigeo = "";
		state.num_incidencia = settingsConfig.num_incidencia;
		state.preliminaryCheckResult = {};
		state.commercialTariffResults = [];
		state.commerceCode = [{ code: null, text: "" }];
		state.affiliateResults = [];
		state.virtual.user = {
			id: 0,
			usingLegalRepresentativeData: false,
			fullname: "",
			email: "",
			phone: ""
		};
		state.virtual.app = {
			id: 0,
			name: "",
			link: "",
			platform: "",
			developer: developer,
			integration: integration
		};
		state.virtual.webSite = {
			id: 0,
			url: "",
			developer: developer,
			integration: integration
		};

		state.typeAffiliation = [{
			codigo: "IND",
			descripcion: "Permanente",
			tipo: "null"
		}, {
			codigo: "TMP",
			descripcion: "Temporal",
			tipo: "null"
		}];
		state.vitualCommerceData = [];
		state.administrativePlatform = [];
		state.idTransaction = null;
		state.validateCrmClientData = null;
		state.consultMcciResult = {};
		state.registerStatus = null;
		state.onHold = null;
		state.applyToCodeQR = false;
		state.corresponsaliaData = {
			header: {
				agent: null,
				affiliationType: null,
				bankAccount: null
			},
			agentData: {
				codigoAgenciaMatriz: null,
				oficinaMatriz: null,
				tipoOficinaMatriz: null,
				ubigeoOficinaMatriz: null,
				codigoMacroRegion: null,
				macroRegion: null,
				area: null
			}
		};
	},
	setIdAffiliation: function setIdAffiliation(state, data) {
		state.idAffiliation = data;
	},
	setStep: function setStep(state, next) {
		next ? state.step += 1 : state.step -= 1;
	},
	setStepNumber: function setStepNumber(state, step) {
		state.step = step;
	},
	setCommercialTariffs: function setCommercialTariffs(state, commercialTariffResults) {
		// console.log("commercialTariffResults1 ", commercialTariffResults);
		while (state.commercialTariffResults.length) {
			state.commercialTariffResults.pop();
		}commercialTariffResults.forEach(function (item) {
			return state.commercialTariffResults.push(item);
		});

		console.log("state.paymentData ", state.paymentData.currencyType);
		console.log("commercialTariffResults2 ", state.commercialTariffResults);
	},
	setPaymentData: function setPaymentData(state, data) {
		state.paymentData = _extends({}, data);

		var rental = state.posSelected.rental[data.currencyType !== currencyTypeEnum.SOLES_Y_DOLARES ? "uniqueMoney" : "biMoney"];

		state.quotation.rentalPrice = rental.soles;
		state.quotation.rentalPriceDolares = rental.dolares;

		var maintenancePriceCost = 0;
		var maintenancePriceCostDolar = 0;

		switch (String(state.posSelected.pos)) {
			case virtualPosEnum.PAGO_LINK:
				maintenancePriceCost = 20;
				maintenancePriceCostDolar = 7;
				break;

			case virtualPosEnum.PAGO_WEB:
				maintenancePriceCost = 50;
				maintenancePriceCostDolar = 15;
				break;

			case virtualPosEnum.PAGO_APP:
				maintenancePriceCost = 0;
				maintenancePriceCostDolar = 0;
				break;

			default:
				break;
		}

		state.quotation.maintenancePriceCost = maintenancePriceCost;
		state.quotation.maintenancePriceCostDolar = maintenancePriceCostDolar;
	},
	setRentalPrice: function setRentalPrice(state) {
		var rental = state.posSelected.rental[state.paymentData.currencyType !== currencyTypeEnum.SOLES_Y_DOLARES ? "uniqueMoney" : "biMoney"];
		state.quotation.rentalPrice = rental.soles;
		state.quotation.rentalPriceDolares = rental.dolares;

		var maintenancePriceCost = 0;
		var maintenancePriceCostDolar = 0;

		switch (String(state.posSelected.pos)) {
			case virtualPosEnum.PAGO_LINK:
				maintenancePriceCost = 20;
				maintenancePriceCostDolar = 7;
				break;

			case virtualPosEnum.PAGO_WEB:
				maintenancePriceCost = 50;
				maintenancePriceCostDolar = 15;
				break;

			case virtualPosEnum.PAGO_APP:
				maintenancePriceCost = 0;
				maintenancePriceCostDolar = 0;
				break;

			default:
				break;
		}

		state.quotation.maintenancePriceCost = maintenancePriceCost;
		state.quotation.maintenancePriceCostDolar = maintenancePriceCostDolar;
	},
	setRucConsultDate: function setRucConsultDate(state, data) {
		state.rucValidation.consultDate = data.LastRequestToSunatDate;

		state.legalRepresentativeData.consultDate = data.LastRequestToSunatDate;
	},
	setBusinessData: function setBusinessData(state, data) {
		state.businessData = data;
		state.ubigeo = calculateUbigeo(state, "commercialAddress");
	},
	setCommerceCode: function setCommerceCode(state, commerceCode) {
		console.log(">>>>>>COMMERCE CODES", commerceCode);
		if (state.multiAdress.length > 0) {
			var _state$commerceCode;

			(_state$commerceCode = state.commerceCode).push.apply(_state$commerceCode, _toConsumableArray(commerceCode));
		} else {
			state.commerceCode = commerceCode;
		}
	},
	setComission: function setComission(state, data) {
		state.comission = data;
	},
	setCommerceCodeInProcess: function setCommerceCodeInProcess(state, id) {
		state.commerceCodeInProcess = id;
	},
	setAffiliateResults: function setAffiliateResults(state, affiliateResults) {
		state.affiliateResults = affiliateResults;
	},
	finishAffiliation: function finishAffiliation(state) {
		// console.log("Finsshing afiliation");
		// console.log("datatable",form.dataTable)
		// console.log("state",state.dataTable)
		state.idAffiliation = 0;
		state.idAffiliationProcess = 0;
		state.step = 1;
		state.productType = null;
		state.productChoice = null;
		state.processInitDate = "";
		state.posSelected = form.posSelected;
		state.rucValidation = form.rucValidation;
		state.membershipType = form.membershipType;
		state.legalRepresentativeData = form.legalRepresentativeData;
		state.businessData = form.businessData;
		state.businessSchedule = form.businessSchedule;
		state.installationSchedule = form.installationSchedule;
		state.paymentData = form.paymentData;
		state.membershipRequirements = form.membershipRequirements;
		state.osvType = form.osvType;
		state.quotation = form.quotation;
		state.afilliationSummary = form.afilliationSummary;
		state.ubigeo = "";
		state.preliminaryCheckResult = form.preliminaryCheckResult;
		state.commercialTariffResults = form.commercialTariffResults;
		state.commerceCode = form.commerceCode;
		state.affiliateResults = form.affiliateResults;
		state.virtual = form.virtual;
		state.virtualComerceData = form.virtualComerceData;
		state.multiAdress = [];
		state.dataTable = [];
		state.infoTable = {
			countInHold: 0,
			countNotWorked: 0,
			countWorked: 0
		};
	},
	setProcessInitDate: function setProcessInitDate(state) {
		state.processInitDate = this.$moment().format("DD/MM/YYYY HH:mm:ss A");
	},
	setShowSteppeds: function setShowSteppeds(state, val) {
		console.log("Changing stepedes", val);
		state.showSteppeds = val;
		// state.step = 7;
	},
	setAdministrativePlataform: function setAdministrativePlataform(state, data) {
		state.virtual.user = _extends({
			id: state.virtual.user.id
		}, data);
	},
	setWebSite: function setWebSite(state, data) {
		state.virtual.webSite = _extends({
			id: state.virtual.webSite.id
		}, data);
	},
	setApp: function setApp(state, data) {
		state.virtual.app = _extends({
			id: state.virtual.app.id
		}, data);
	},
	setFromAffiliationInProcess: function setFromAffiliationInProcess(state, _ref114) {
		var affiliationProcess = _ref114.affiliationProcess,
		    masterData = _ref114.masterData;

		if (!affiliationProcess) return;

		var products = masterData.products,
		    banks = masterData.banks,
		    opCommercialBusiness = masterData.opCommercialBusiness;

		var idProduct = affiliationProcess.IdProduct;
		var product = products.find(function (p) {
			return p.IdProduct === idProduct;
		}) || {};

		var maintenancePriceCost = 0;
		var maintenancePriceCostDolar = 0;

		switch (String(state.posSelected.pos)) {
			case virtualPosEnum.PAGO_LINK:
				maintenancePriceCost = 20;
				maintenancePriceCostDolar = 7;
				break;

			case virtualPosEnum.PAGO_WEB:
				maintenancePriceCost = 50;
				maintenancePriceCostDolar = 15;
				break;

			case virtualPosEnum.PAGO_APP:
				maintenancePriceCost = 0;
				maintenancePriceCostDolar = 0;
				break;

			default:
				break;
		}

		var productType = void 0,
		    productJson = void 0,
		    commercialAddress = {},
		    administrativeAddress = {},
		    paymentDataSoles = {},
		    paymentDataDolares = {};

		if ([1, 2, 3, 12].indexOf(Number(idProduct)) > -1) {
			productType = 1;
			productJson = pos;
		} else {
			productType = 2;
			productJson = virtual;
		}

		var productJsonItem = productJson[productType] || {};

		var _ref115 = productJsonItem.rental || {
			uniqueMoney: {},
			biMoney: {}
		},
		    uniqueMoney = _ref115.uniqueMoney,
		    biMoney = _ref115.biMoney;

		state.registerStatus = affiliationProcess.Affiliation.RegisterStatus;
		state.idTransaction = affiliationProcess.RqUID;
		state.validateCrmClientData = {
			SIC: affiliationProcess.CrmSic,
			Desc: affiliationProcess.CrmDesc
		};
		state.onHold = affiliationProcess.Affiliation.OnHold;
		state.idAffiliation = affiliationProcess.Affiliation.IdAffiliation;
		state.idAffiliationProcess = affiliationProcess.IdAffiliationProcess;
		state.step = affiliationProcess.Step;
		state.showSteppeds = true;
		state.productType = String(productType), state.productChoice = product.Name, state.processInitDate = null, state.posSelected = {
			pos: product.Name,
			id: product.IdProduct,
			priceSoles: productJsonItem.priceSoles || null,
			priceDolares: productJsonItem.priceDolares || null,
			TipoConexion: productJsonItem.TipoConexion || null,
			rental: {
				uniqueMoney: {
					soles: Number(uniqueMoney.soles),
					dolares: Number(uniqueMoney.dolares)
				},
				biMoney: {
					soles: Number(biMoney.soles),
					dolares: Number(biMoney.dolares)
				}
			},
			tarifas: productJsonItem.tarifas || {},
			usePlatformWebCost: productJsonItem.usePlatformWebCost || null
		};
		state.rucValidation = {
			ruc: affiliationProcess.Ruc,
			businessName: affiliationProcess.BusinessName
		};
		state.membershipType = {
			type: "IND",
			startDate: null,
			endDate: null
		};

		if (Array.isArray(affiliationProcess.LegalRepresentatives) && affiliationProcess.LegalRepresentatives.length) {
			var legalRepresentative = affiliationProcess.LegalRepresentatives[0];

			state.legalRepresentativeData = {
				id: legalRepresentative.IdLegalRepresentative,
				firstName: legalRepresentative.FirstName,
				maternalName: legalRepresentative.MaternalName,
				paternalName: legalRepresentative.PaternalName,
				documentType: masterData.documentTypes.find(function (dt) {
					return dt.IdDocumentType === legalRepresentative.IdDocumentType;
				}) || {
					IdDocumentType: legalRepresentative.IdDocumentType
				},
				documentNumber: legalRepresentative.DocumentNumber,
				cellPhone: legalRepresentative.CellPhone,
				secondPhone: legalRepresentative.SecondPhone,
				email: legalRepresentative.Email,
				birthdate: legalRepresentative.Birthdate
			};
		}

		if (Array.isArray(affiliationProcess.AffiliationAddress) && affiliationProcess.AffiliationAddress.length) {
			administrativeAddress = affiliationProcess.AffiliationAddress.find(function (a) {
				return a.IdAddressType === AddressTypeEnum.ADMINISTRATIVE_ADDRESS;
			}) || {};
			commercialAddress = affiliationProcess.AffiliationAddress.find(function (a) {
				return a.IdAddressType === AddressTypeEnum.COMMERCIAL_ADDRESS;
			}) || {};
		}

		state.businessData = {
			adminCommerEquals: affiliationProcess.AddressEquals,
			commerceData: {
				tradeName: affiliationProcess.Tradename,
				email: affiliationProcess.Email,
				commercialBusiness: opCommercialBusiness.find(function (cb) {
					return cb.IdBusinessTurn === affiliationProcess.IdBusinessTurn;
				}) || {},
				nationalMcc: affiliationProcess.Nationalmcc,
				applyToPartnerPlan: affiliationProcess.ApplyToPartnerPlan
			},
			commercialAddress: {
				id: commercialAddress.IdCommercialAddress,
				department: masterData.departments.find(function (d) {
					return d.IdDepartament === commercialAddress.IdDepartament;
				}) || {
					IdDepartament: commercialAddress.IdDepartament
				},
				province: { IdProvince: commercialAddress.IdProvince },
				district: { IdDistrict: commercialAddress.IdDistrict },
				typeOfRoad: masterData.typeRoads.find(function (tr) {
					return tr.IdTypeOfRoad === commercialAddress.IdTypeOfRoad;
				}) || { IdTypeOfRoad: commercialAddress.IdTypeOfRoad },
				nameOfRoad: commercialAddress.NameOfRoad,
				numberOfRoad: commercialAddress.NumberOfRoad,
				plusCode: commercialAddress.plusCode,
				km: commercialAddress.Km,
				block: commercialAddress.Block,
				allotment: commercialAddress.Allotment,
				interiorType: masterData.typeInteriors.find(function (ty) {
					return ty.IdInteriorType === commercialAddress.IdInteriorType;
				}) || {
					IdInteriorType: commercialAddress.IdInteriorType
				},
				interior: commercialAddress.Interior,
				reference: commercialAddress.Reference,
				typeUrbanHabilitation: commercialAddress.TypeUrbanHabilitation,
				urbanHabilitation: commercialAddress.UrbanHabilitation,
				cellPhone: commercialAddress.CellPhone,
				prefix: commercialAddress.Prefix,
				landline: commercialAddress.LandLine
			},
			administrativeAddress: {
				id: commercialAddress.IdAdministrativeAddress,
				department: masterData.departments.find(function (d) {
					return d.IdDepartament === administrativeAddress.IdDepartament;
				}) || {
					IdDepartament: administrativeAddress.IdDepartament
				},
				province: { IdProvince: administrativeAddress.IdProvince },
				district: { IdDistrict: administrativeAddress.IdDistrict },
				typeOfRoad: masterData.typeRoads.find(function (tr) {
					return tr.IdTypeOfRoad === administrativeAddress.IdTypeOfRoad;
				}) || {
					IdTypeOfRoad: administrativeAddress.IdTypeOfRoad
				},
				nameOfRoad: administrativeAddress.NameOfRoad,
				numberOfRoad: administrativeAddress.NumberOfRoad,
				plusCode: administrativeAddress.plusCode,
				km: administrativeAddress.Km,
				block: administrativeAddress.Block,
				allotment: administrativeAddress.Allotment,
				interiorType: masterData.typeInteriors.find(function (ty) {
					return ty.IdInteriorType === administrativeAddress.IdInteriorType;
				}) || {
					IdInteriorType: administrativeAddress.IdInteriorType
				},
				interior: administrativeAddress.Interior,
				reference: administrativeAddress.Reference,
				typeUrbanHabilitation: administrativeAddress.TypeUrbanHabilitation,
				urbanHabilitation: administrativeAddress.UrbanHabilitacion,
				cellPhone: administrativeAddress.CellPhone,
				prefix: administrativeAddress.Prefix,
				landline: administrativeAddress.LandLine
			}
		};

		if (Array.isArray(affiliationProcess.BusinessSchedules) && affiliationProcess.BusinessSchedules.length) {
			var businessSchedule = affiliationProcess.BusinessSchedules[0];
			state.businessSchedule = {
				id: businessSchedule.IdBusinessSchedule,
				idSchedule: null,
				schedule: [],
				initDay: "",
				endDay: "",
				startTime: businessSchedule.StartTime,
				endTime: businessSchedule.EndTime
			};

			if (Array.isArray(businessSchedule.Schedules) && businessSchedule.Schedules.length) {
				var schedule = businessSchedule.Schedules[0];
				state.businessSchedule.idSchedule = schedule.IdSchedule;
				state.businessSchedule.schedule = [isNaN(schedule.monday) ? -1 : schedule.monday, isNaN(schedule.tuesday) ? -1 : schedule.tuesday, isNaN(schedule.wednesday) ? -1 : schedule.wednesday, isNaN(schedule.thursday) ? -1 : schedule.thursday, isNaN(schedule.friday) ? -1 : schedule.friday, isNaN(schedule.saturday) ? -1 : schedule.saturday, isNaN(schedule.sunday) ? -1 : schedule.sunday].filter(function (val) {
					return val > -1;
				});
			}
		}

		if (Array.isArray(affiliationProcess.InstallationSchedules) && affiliationProcess.InstallationSchedules.length) {
			var installationSchedule = affiliationProcess.InstallationSchedules[0];
			state.installationSchedule = {
				id: installationSchedule.IdInstallationSchedule,
				serviceHours: !Array.isArray(installationSchedule.ServiceHours) ? [] : installationSchedule.ServiceHours.map(function (sh) {
					return sh.IdAttetionHourse;
				}),
				name: installationSchedule.Name,
				phone: installationSchedule.Phone,
				paternalLastname: installationSchedule.PaternalName, // TODO: falta guardar este dato en el servicio
				maternalLastname: installationSchedule.MaternalName, // TODO: falta guardar este dato en el servicio
				documentType: masterData.documentTypes.find(function (dt) {
					return dt.IdDocumentType === installationSchedule.IdDocumentType;
				}) || {
					IdDocumentType: installationSchedule.IdDocumentType
				},
				documentNumber: installationSchedule.DocumentNumber,
				email: installationSchedule.Email // TODO: falta guardar este dato en el servicio
			};
		}

		if (Array.isArray(affiliationProcess.BankAccounts) && affiliationProcess.BankAccounts.length) {
			paymentDataSoles = affiliationProcess.BankAccounts.find(function (ba) {
				return ba.IdCurrency === 1;
			}) || {}; /** Soles */
			paymentDataDolares = affiliationProcess.BankAccounts.find(function (ba) {
				return ba.IdCurrency === 2;
			}) || {}; /** Dolares */
		}

		state.paymentData = {
			currencyType: paymentDataSoles.IdBank && paymentDataDolares.IdBank ? currencyTypeEnum.SOLES_Y_DOLARES : paymentDataSoles.IdBank ? currencyTypeEnum.SOLES : paymentDataDolares.IdBank ? currencyTypeEnum.DOLARES : {},
			idSoles: paymentDataSoles.IdBankAccount,
			bankNameSoles: Array.isArray(banks) ? banks.find(function (b) {
				return b.IdBank === paymentDataSoles.IdBank;
			}) || {} : {},
			accountTypeSoles: {
				IdTypeAccount: paymentDataSoles.IdTypeAccount || null
			},
			accountNumberSoles: paymentDataSoles.AccountNumber || null,
			alternativeAccountNumberSoles: affiliationProcess.AlternativeAccountNumberSoles,

			idDolares: paymentDataDolares.IdBankAccount,
			bankNameDolares: Array.isArray(banks) ? banks.find(function (b) {
				return b.IdBank === paymentDataDolares.IdBank;
			}) || {} : {},
			accountTypeDolares: {
				IdTypeAccount: paymentDataDolares.IdTypeAccount || null
			},
			accountNumberDolares: paymentDataDolares.AccountNumber || null,
			alternativeAccountNumberDolares: affiliationProcess.AlternativeAccountNumberDolares
		};
		//add ModalityType

		if (Array.isArray(affiliationProcess.MemberShipRequirements) && affiliationProcess.MemberShipRequirements.length) {
			var data = affiliationProcess.MemberShipRequirements;
			for (var i = 0; i < data.length; i++) {
				state.membershipRequirements = {
					url: affiliationProcess.MemberShipRequirements,
					sapFiles: []
				};
				affiliationProcess.MemberShipRequirements;
			}
		}

		state.osvType = {
			osvType: affiliationProcess.IdTypeOSV,
			commercialCode: affiliationProcess.OSVCommercialCode
		};
		state.quotation = {
			posName: product.Name,
			posNumber: "1",
			taxQuota: "01",
			installationCost: null,
			installationCostDolar: null,
			rentalPrice: 0.0,
			rentalPriceDolares: 0.0,
			maintenancePriceCost: maintenancePriceCost,
			maintenancePriceCostDolar: maintenancePriceCostDolar,
			stateShippingCost: 5.0,
			stateShippingCostDolar: 1.5,
			creditCardCommission: "4.5%",
			debitCardCommission: "3.8%"
		};

		if (Array.isArray(affiliationProcess.AffiliationSummarys) && affiliationProcess.AffiliationSummarys.length) {
			var affiliationSummary = affiliationProcess.AffiliationSummarys[0];
			state.afilliationSummary = {
				id: affiliationSummary.IdAffiliationSummary,
				equiptment: affiliationSummary.QuantityEquipment,
				dues: affiliationSummary.Dues
			};
		}

		var commerceCodes = [];

		affiliationProcess.Affiliation.CommerceCodePEN && commerceCodes.push({
			code: affiliationProcess.Affiliation.CommerceCodePEN,
			text: "para Soles"
		});
		affiliationProcess.Affiliation.CommerceCodeUSD && commerceCodes.push({
			code: affiliationProcess.Affiliation.CommerceCodeUSD,
			text: "para Dolares"
		});

		state.commerceCode = commerceCodes;

		var administrativePlatform = Array.isArray(affiliationProcess.AdministrativePlatforms) && affiliationProcess.AdministrativePlatforms.length ? affiliationProcess.AdministrativePlatforms[0] : {};

		var virtualCommerceData = Array.isArray(affiliationProcess.VirtualCommerceDatas) && affiliationProcess.VirtualCommerceDatas.length ? affiliationProcess.VirtualCommerceDatas[0] : {};

		state.virtual = {
			user: {
				id: Number(administrativePlatform.IdAdministrativePlatform),
				usingLegalRepresentativeData: false,
				fullname: administrativePlatform.FirstLastName || "",
				email: administrativePlatform.Email || "",
				phone: administrativePlatform.Cellphone || ""
			},
			app: {
				id: Number(virtualCommerceData.IdVirtualCommerceData),
				name: virtualCommerceData.NameAPP || "",
				link: virtualCommerceData.LinkAPP || "",
				platform: virtualCommerceData.IdPlatform || null,
				developer: {
					developmentType: virtualCommerceData.IdTypeOfDevelopment || "",
					company: virtualCommerceData.EnterpriseName || "",
					fullname: virtualCommerceData.ContactName || "",
					email: virtualCommerceData.Email || "",
					phone: virtualCommerceData.ContactCellphone || ""
				},
				integration: {
					paymentForm: ""
				}
			},
			webSite: getters.isPagoWeb ? {
				id: Number(virtualCommerceData.IdVirtualCommerceData),
				url: virtualCommerceData.LinkAPP || "",
				developer: {
					developmentType: virtualCommerceData.IdTypeOfDevelopment || "",
					company: virtualCommerceData.EnterpriseName || "",
					fullname: virtualCommerceData.ContactName || "",
					phone: virtualCommerceData.ContactCellphone || "",
					email: virtualCommerceData.Email
				},
				integration: {
					paymentForm: ""
				}
			} : {
				id: 0,
				url: "",
				developer: {
					developmentType: "",
					company: null,
					fullname: null,
					email: null,
					phone: null
				},
				integration: {
					paymentForm: ""
				}
			}
		};
	},
	recalculateUbigeo: function recalculateUbigeo(state) {
		state.ubigeo = calculateUbigeo(state, "commercialAddress");
	},
	setProvince: function setProvince(state, _ref116) {
		var addressPropertyType = _ref116.addressPropertyType,
		    province = _ref116.province;

		state.businessData[addressPropertyType].province = province;
	},
	setDistrict: function setDistrict(state, _ref117) {
		var addressPropertyType = _ref117.addressPropertyType,
		    district = _ref117.district;

		state.businessData[addressPropertyType].district = district;
	},
	setIncidenceNumber: function setIncidenceNumber(state, incidenceNumber) {
		state.num_incidencia = incidenceNumber || settingsConfig.num_incidencia;
	},
	setIdTransaction: function setIdTransaction(state, idTransaction) {
		state.idTransaction = idTransaction;
	},
	setValidateCrmClientData: function setValidateCrmClientData(state, validateCrmClientData) {
		state.validateCrmClientData = validateCrmClientData;
	},
	setConsultMcciResult: function setConsultMcciResult(state, consultMcciResult) {
		state.consultMcciResult = _extends({}, consultMcciResult);
	},
	setOnHold: function setOnHold(state, onHold) {
		state.onHold = onHold;
	},
	setMultiAdress: function setMultiAdress(state, multiAdress) {
		if (Array.isArray(multiAdress) && multiAdress.length > 0) {
			state.multiAdress = multiAdress;
		}
	},
	setinMultiAdressisSameDirection: function setinMultiAdressisSameDirection(state, inMultiAdressisSameDirection) {
		state.inMultiAdressisSameDirection = inMultiAdressisSameDirection;
	},
	functionProccesTable: function functionProccesTable(state, _ref118) {
		var resultCommer = _ref118.resultCommer,
		    indice = _ref118.indice;

		var dir = state.multiAdress[indice];
		if (resultCommer.isFailed) {
			state.infoTable.countNotWorked += 1;
			state.dataTable.push({
				direccion: dir.typeOfRoad.Description + " " + dir.nameOfRoad + " " + dir.numberOfRoad + ", " + dir.province.Name + ", " + dir.district.Name,
				name: state.rucValidation.businessName,
				moneda: 'Soles',
				codigo: 'FAILED'
			});
			if (state.currencyTypeBimoneda === currencyTypeEnum.SOLES_Y_DOLARES) {
				state.infoTable.countNotWorked += 1;
				state.dataTable.push({
					direccion: dir.typeOfRoad.Description + " " + dir.nameOfRoad + " " + dir.numberOfRoad + ", " + dir.province.Name + ", " + dir.district.Name,
					name: state.rucValidation.businessName,
					moneda: 'Dolares',
					codigo: 'FAILED'
				});
			}
		} else {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = _getIterator(resultCommer.arrayResult), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (resultCommer.inHold) state.infoTable.countInHold += 1;else state.infoTable.countWorked += 1;
					state.dataTable.push({
						direccion: dir.typeOfRoad.Description + " " + dir.nameOfRoad + " " + dir.numberOfRoad + ", " + dir.province.Name + ", " + dir.district.Name,
						name: state.rucValidation.businessName,
						moneda: (item.text || '') == 'para Soles' ? 'Soles' : 'Dolares',
						codigo: (item.code || '').length > 0 && item.code != 0 ? item.code : (item.resultApi || { id: '' }).id
					});
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/affiliations/form.js
// module id = ./src/store/affiliations/form.js
// module chunks = 34